import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';
import InputMask from 'react-input-mask';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Nav, NavItem, NavLink, TabContent, TabPane, InputGroup, Alert, Badge } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import classnames from 'classnames';
import api from '../../api';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { useToast } from "../../context/ToastContext";
import { encryptId } from '../../utils/cryptoUtils';
import { Calendar, momentLocalizer, SlotInfo } from 'react-big-calendar';
import withDragAndDrop, { EventInteractionArgs } from 'react-big-calendar/lib/addons/dragAndDrop';
import Select from "react-select";
import AsyncSelect from "react-select/async";
import moment from 'moment';
import 'moment/locale/pt-br';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import type { View } from 'react-big-calendar';

import { CreateAlunoModal } from '../../components/Aluno/CreateAlunoModal';
import { EditAlunoModal } from '../../components/Aluno/EditAlunoModal';
import AlunosSemVinculoModal from '../../components/Aluno/AlunosSemVinculoModal';
import { CreateCustoModal } from '../../components/Custo/CreateCustoModal';
import { EditCustoModal } from '../../components/Custo/EditCustoModal';
import { CreateInstituicaoModal } from '../../components/Instituicao/CreateInstituicaoModal';
import { CreateCursoModal } from '../../components/Curso/CreateCursoModal';
import { CreateTerceiroModal } from '../../components/Terceiro/CreateTerceiroModal';
import { CreateAgendaModal } from '../../components/Agenda/CreateAgendaModal';
import { EditAgendaModal } from '../../components/Agenda/EditAgendaModal';

import { AuthContext } from '../../context/AuthContext';
import { ContratoContext } from '../../context/ContratoContext';
import { InstituicaoContext } from '../../context/InstituicaoContext';
import { AlunoContext } from '../../context/AlunoContext';
import { CursoContext } from '../../context/CursoContext';
import { ResponsavelContext } from '../../context/ResponsavelContext';
import { TipoCustoContext } from '../../context/TipoCustoContext';
import { CustoContext } from '../../context/CustoContext';
import { AgendaContext } from '../../context/AgendaContext';
import { TipoAgendaContext } from '../../context/TipoAgendaContext';
import { TerceiroContext } from '../../context/TerceiroContext';
import { PreparacaoAlbumContext } from '../../context/PreparacaoAlbumContext';
import { ObservacaoContratoContext } from '../../context/ObservacaoContratoContext';
import { ContratoStatusReportContext } from '../../context/ContratoStatusReportContext';
import { ContratoStatusReportFilters } from '../../context/hooks/useContratoStatusReport';
import { ExportContratoRelatorioModal } from '../../components/Contrato/ExportContratoRelatorioModal';

import { ContratoType, CreateContratoType, UpdateContratoType, ContratoAssinaturaType, FlashCnpjType } from '../../context/hooks/useContrato';
import { AlunoType, CreateAlunoType, EditAlunoType, AlunoRelatorioRequest, CopyTransferAlunosRequest, AlunoCursoItem } from '../../context/hooks/useAluno';
import { CursoType } from '../../context/hooks/useCurso';
import { CustoType, CreateCustoType, EditCustoType } from '../../context/hooks/useCusto';
import { AgendaType, CreateAgendaType, EditAgendaType } from '../../context/hooks/useAgenda';
import { TipoAgendaType } from '../../context/hooks/useTipoAgenda';
import { TerceiroType } from '../../context/hooks/useTerceiro';
import { PreparacaoAlbumType, CreatePreparacaoAlbumType, EditPreparacaoAlbumType } from '../../context/hooks/usePreparacaoAlbum';
import { CreateInstituicaoType } from '../../context/hooks/useInstituicao';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';
import { CreateResponsavelType } from '../../context/hooks/useResponsavel';
import { ObservacaoContratoType, CreateObservacaoContratoType, EditObservacaoContratoType } from '../../context/hooks/useObservacaoContrato';

import useUser from '../../context/hooks/useUser';

moment.locale('pt-br');
const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const messages = {
    allDay: 'Dia inteiro',
    previous: 'Anterior',
    next: 'Próximo',
    today: 'Hoje',
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    agenda: 'Agenda',
    date: 'Data',
    time: 'Hora',
    event: 'Evento',
    noEventsInRange: 'Nenhum evento nesse período.',
    showMore: (total: number) => `+ Ver mais (${total})`
};

const RELATORIO_FIELDS = [
    { label: "Sequência", value: "AlunoId" },
    { label: "Código de referência", value: "ReferenceCode" },
    { label: "Nome", value: "AlunoNome" },
    { label: "Email", value: "Email" },
    { label: "Curso", value: "CursoNome" },
    { label: "CPF", value: "CPF" },
    { label: "Endereço", value: "Address" },
    { label: "Nº", value: "AddressNumber" },
    { label: "Bairro", value: "Neighborhood" },
    { label: "Cidade", value: "City" },
    { label: "Estado", value: "State" },
    { label: "CEP", value: "ZipCode" },
    { label: "Fixo", value: "Landline" },
    { label: "Tel 01", value: "Telephone_01" },
    { label: "Tel 02", value: "Telephone_02" },
    { label: "Tel 03", value: "Telephone_03" },
    { label: "Tel 04", value: "Telephone_04" },
    { label: "Tel 05", value: "Telephone_05" },
    { label: "Tel 06", value: "Telephone_06" },
    { label: "Facebook", value: "Facebook" },
    { label: "Instagram", value: "Instagram" },
    { label: "Manter as fotos?", value: "KeepThePhotos" },
    { label: "Possui álbum?", value: "HasAlbum" },
    { label: "Nº de fotos", value: "NumberOfPhotos" },
    { label: "Contrato", value: "Contrato" },
    { label: "Instituição", value: "Instituicao" },
    { label: "Data de Cadastro", value: "DataCadastro" },
];

type PeriodoRelatorio = '' | 'diario' | 'mensal' | 'trimestral' | 'semestral' | 'anual';

// Traduz a opção de período (Diário/Mensal/Trimestral/Semestral/Anual) + uma data de referência
// (padrão: hoje) no intervalo de datas de cadastro que o backend espera. Trimestre/semestre seguem
// o calendário civil (jan-mar/abr-jun/... e jan-jun/jul-dez), não uma janela móvel de N meses.
function calcularPeriodoRelatorio(periodo: PeriodoRelatorio, dataReferencia: string): { dataInicio?: string; dataFim?: string } {
    if (!periodo) return {};

    const ref = dataReferencia ? moment(dataReferencia) : moment();
    let inicio = ref.clone();
    let fim = ref.clone();

    switch (periodo) {
        case 'diario':
            inicio = ref.clone().startOf('day');
            fim = ref.clone().endOf('day');
            break;
        case 'mensal':
            inicio = ref.clone().startOf('month');
            fim = ref.clone().endOf('month');
            break;
        case 'trimestral': {
            const trimestre = Math.floor(ref.month() / 3);
            inicio = ref.clone().month(trimestre * 3).startOf('month');
            fim = inicio.clone().add(2, 'months').endOf('month');
            break;
        }
        case 'semestral': {
            const semestre = ref.month() < 6 ? 0 : 1;
            inicio = ref.clone().month(semestre * 6).startOf('month');
            fim = inicio.clone().add(5, 'months').endOf('month');
            break;
        }
        case 'anual':
            inicio = ref.clone().startOf('year');
            fim = ref.clone().endOf('year');
            break;
    }

    return {
        dataInicio: inicio.format('YYYY-MM-DDTHH:mm:ss'),
        dataFim: fim.format('YYYY-MM-DDTHH:mm:ss'),
    };
}

const Contrato = () => {
    const showToast = useToast();
    const { objUserTk } = useContext(AuthContext);
    const { listContrato, pageCount, getAllContratoPaged, createContrato, updateContrato, deleteContrato, downloadContratoPdf, suggestContratoDescriptions, addCursoAoContrato, removeCursoDoContrato, enviarParaAssinatura, getStatusAssinatura, getFlashCnpjs } = useContext(ContratoContext);
    const { createAluno, getAlunoPaged, updateAluno, deleteAluno, setListAluno, listAluno, alunoPageCount, setAlunoPageCount, totalAlunos, setTotalAlunos, gerarRelatorioAlunos, copyTransferAlunos, removeAlunoFromContrato, getAlunosSemVinculo, revinculaAluno } = useContext(AlunoContext);
    const { handleGetInstituicaoByEmpresaId, listInstituicao, createInstituicao, getInstituicaoPaged } = useContext(InstituicaoContext);
    const { handleGetCursoByEmpresaId, listCurso, handleGetCursoByContratoId, listCursoByContrato, setListCursoByContrato } = useContext(CursoContext);
    const { getTerceiroPaged, listTerceiro, handleGetTerceiroByAgendaId, listTerceiroByAgenda, listEditor, handleGetEditorsByEmpresa, listLaboratory, handleGetLaboratoriesByEmpresa, handleGetVendedoresByEmpresa, listVendedores, handleGetRepresentanteComercialByEmpresa, listRepresentanteComercial } = useContext(TerceiroContext);
    const { handleGetResponsavelByInstituicaoId, listResponsavel } = useContext(ResponsavelContext);
    const { getAllTipoCustoPaged, listTipoCusto } = useContext(TipoCustoContext);
    const { createCusto, deleteCusto, getCustoFinanceiroPaged, listCustoFinanceiro, custoFinanceiroPageCount, getCustoGeralPaged, listCustoGeral, custoGeralPageCount, exportCustoBytes, totaisFinanceiro, totaisGeral, enviarCustoParaFinanceiro } = useContext(CustoContext);
    const { createAgenda, listAgenda, getAgendaPaged, updateAgenda, deleteAgenda, downloadAgendaPdfCustom, listAllAgenda, printAgendaPdfByDate, printAgendaPdfCustom, setListAgenda } = useContext(AgendaContext);
    const { getAllTipoAgendaPaged, listTipoAgenda } = useContext(TipoAgendaContext);
    const { createPreparacaoAlbum, getPreparacaoAlbumPaged, updatePreparacaoAlbum, deletePreparacaoAlbum, listPreparacaoAlbum, preparacaoAlbumPageCount, setListPreparacaoAlbum, setPreparacaoAlbumPageCount } = useContext(PreparacaoAlbumContext);
    const { createObservacaoContrato, getObservacaoContratoPaged, updateObservacaoContrato, deleteObservacaoContrato, listObservacaoContrato, observacaoContratoPageCount, setListObservacaoContrato, setObservacaoContratoPageCount } = useContext(ObservacaoContratoContext);
    const { exportContratoStatusReportPdf, exportContratoStatusReportExcel } = useContext(ContratoStatusReportContext);
    const [statusRelatorioContratos, setStatusRelatorioContratos] = useState<string>('');
    const [editorRelatorioContratos, setEditorRelatorioContratos] = useState<string>('');
    const [laboratorioRelatorioContratos, setLaboratorioRelatorioContratos] = useState<string>('');
    const [dataInicialRelatorioContratos, setDataInicialRelatorioContratos] = useState<string>('');
    const [dataFinalRelatorioContratos, setDataFinalRelatorioContratos] = useState<string>('');
    const [isExportRelatorioModalOpen, setIsExportRelatorioModalOpen] = useState<boolean>(false);

    // Reaproveitado pelos botões PDF e Excel do modal de exportação: precisa ficar em sincronia
    // com os filtros que o backend aceita em FiltersContratoStatusReportDTO.
    function getContratoStatusReportFilters(overrideVendedorId?: number): ContratoStatusReportFilters {
        const vendedor = overrideVendedorId !== undefined ? (overrideVendedorId || undefined) : (dataSearch.vendedorId || undefined);
        return {
            EmpresaId: objUserTk.EmpresaId,
            City: dataSearch.city || undefined,
            State: dataSearch.state || undefined,
            Description: dataSearch.description || undefined,
            StatusConsolidado: statusRelatorioContratos ? Number(statusRelatorioContratos) : undefined,
            EditorId: editorRelatorioContratos ? Number(editorRelatorioContratos) : undefined,
            LaboratorioId: laboratorioRelatorioContratos ? Number(laboratorioRelatorioContratos) : undefined,
            VendedorId: vendedor,
            StartDate: dataInicialRelatorioContratos || undefined,
            EndDate: dataFinalRelatorioContratos || undefined,
        };
    }

    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);

    const [selectedInstituicaoId, setSelectedInstituicaoId] = useState(0);
    const [selectedContratoId, setSelectedContratoId] = useState(0);
    const [selectedTerceiros, setSelectedTerceiros] = useState<TerceiroType[]>([]);

    const [customStartDate, setCustomStartDate] = useState("");
    const [customEndDate, setCustomEndDate] = useState("");
    const [selectedAgendaIds, setSelectedAgendaIds] = useState<number[]>([]);

    const [descSuggestions, setDescSuggestions] = useState<string[]>([]);
    const [isLoadingDesc, setIsLoadingDesc] = useState(false);

    const [selectedCursosToAdd, setSelectedCursosToAdd] = useState<number[]>([]);
    const [isSyncingCursos, setIsSyncingCursos] = useState(false);

    const [selectedFields, setSelectedFields] = useState<string[]>([
        "AlunoId", "AlunoNome", "Email"
    ]);
    const [relatorioTodosContratos, setRelatorioTodosContratos] = useState(false);
    const [relatorioPeriodo, setRelatorioPeriodo] = useState<PeriodoRelatorio>('');
    const [relatorioDataReferencia, setRelatorioDataReferencia] = useState<string>('');
    const [relatorioNomeFormando, setRelatorioNomeFormando] = useState<string>('');

    const [selectedCursoFiltroAlunos, setSelectedCursoFiltroAlunos] = useState<{ value: number; label: string } | null>(null);
    const [referenceCodeFiltroAlunos, setReferenceCodeFiltroAlunos] = useState<string>('');

    const [slotStart, setSlotStart] = useState<string>('');
    const [slotEnd, setSlotEnd] = useState<string>('');

    const [newContrato, setNewContrato] = useState<CreateContratoType>({
        description: '',
        contractAnnex: '',
        class: '',
        hiredStudents: 0,
        currentStudents: 0,
        completionDate: '',
        dateOfDischarge: '',
        linkSent: false,
        freebies: false,
        empresaId: objUserTk.EmpresaId,
        instituicaoId: 0,
        cursoId: [],
        vendedorId: 0,
        responsavelId: 0,
        alunoId: [],
        agendaId: [],
    });
    const [custos, setCustos] = useState<CreateCustoType[]>([]);
    const [newCusto, setNewCusto] = useState<CreateCustoType>({
        description: '',
        proportionalCurrentStudents: false,
        individualValue: 0,
        currentBalance: 0,
        requestDate: '',
        deliveryDate: '',
        paymentDate: '',
        receiver: '',
        observation: '',
        isPaid: false,
        empresaId: objUserTk.EmpresaId,
        contratoId: 0,
        tipoCustoId: selectedContratoId,
    });
    const [newPreparacaoAlbum, setNewPreparacaoAlbum] = useState<CreatePreparacaoAlbumType>({
        description: "",
        numberOfPhotos: 0,
        numberOfPhotosLaboratory: 0,
        numberOfAlbums: 0,
        editorDeliveryDate: "",
        editorReturnDate: "",
        laboratoryDeliveryDate: "",
        laboratoryReturnDate: "",
        kit30x60: false,
        kit30x60Quantities: 0,
        kit10x15: false,
        kit10x15Quantities: 0,
        kit28x35: false,
        kit28x35Quantities: 0,
        empresaId: objUserTk.EmpresaId,
        contratoId: selectedContratoId,
        editorId: 0,
        laboratorioId: 0,
    });
    const [newObservacaoContrato, setNewObservacaoContrato] = useState<CreateObservacaoContratoType>({
        observation: "",
        date: "",
        contratoId: null,
    });

    const [editingContrato, setEditingContrato] = useState<UpdateContratoType | null>(null);
    const [editingCusto, setEditingCusto] = useState<EditCustoType | null>(null);
    const [editingAluno, setEditingAluno] = useState<EditAlunoType | null>(null);
    const [editingAgenda, setEditingAgenda] = useState<EditAgendaType | null>(null);
    const [editingPreparacaoAlbum, serEditingPreparacaoAlbum] = useState<EditPreparacaoAlbumType | null>(null);
    const [editingObservacaoContrato, setEditingObservacaoContrato] = useState<EditObservacaoContratoType | null>(null);

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [createAlunoModalOpen, setCreateAlunoModalOpen] = useState(false);
    const [createCustoModalOpen, setCreateCustoModalOpen] = useState(false);
    const [createAgendaModalOpen, setCreateAgendaModalOpen] = useState(false);
    const [createPreparacaoAlbumModalOpen, setCreatePreparacaoAlbumModalOpen] = useState(false);
    const [createInstituicaoModalOpen, setCreateInstituicaoModalOpen] = useState(false);
    const [createObservacaoContratoModalOpen, setCreateObservacaoContratoModalOpen] = useState(false);
    const [createCursoModalOpen, setCreateCursoModalOpen] = useState(false);
    const [createVendedorModalOpen, setCreateVendedorModalOpen] = useState(false);
    const [createEditorModalOpen, setCreateEditorModalOpen] = useState(false);
    const [createLabModalOpen, setCreateLabModalOpen] = useState(false);

    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editCustoModalOpen, setEditCustoModalOpen] = useState(false);
    const [editAlunoModalOpen, setEditAlunoModalOpen] = useState(false);
    const [editAgendaModalOpen, setEditAgendaModalOpen] = useState(false);
    const [editPreparacaoAlbumModalOpen, setEditPreparacaoAlbumModalOpen] = useState(false);
    const [editObservacaoContratoModalOpen, setEditObservacaoContratoModalOpen] = useState(false);

    const [alunosSemVinculoModalOpen, setAlunosSemVinculoModalOpen] = useState(false);

    type PendingDeleteType =
        | "contrato"
        | "aluno"
        | "removeAlunoFromContrato"
        | "custo"
        | "agenda"
        | "preparacaoAlbum"
        | "observacaoContrato"
        | "removerCursoDoContrato";

    interface PendingDelete {
        type: PendingDeleteType;
        ids: Record<string, number>;
        force: boolean;
        title: string;
        message: string;
    }

    const [pendingDelete, setPendingDelete] = useState<PendingDelete | null>(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const closeDeleteModal = () => {
        setPendingDelete(null);
        setDeleteLoading(false);
    };

    const formatDependentes = (dependentes: Record<string, number>) =>
        Object.entries(dependentes)
            .filter(([, count]) => count > 0)
            .map(([label, count]) => `${count} ${label.toLowerCase()}`)
            .join(", ");

    const [assinaturaModalOpen, setAssinaturaModalOpen] = useState(false);
    const [assinaturaContratoId, setAssinaturaContratoId] = useState<number | null>(null);
    const [assinaturaStatus, setAssinaturaStatus] = useState<ContratoAssinaturaType | null>(null);
    const [assinaturaLoading, setAssinaturaLoading] = useState(false);
    const [flashCnpjs, setFlashCnpjs] = useState<FlashCnpjType[]>([]);
    const [cnpjAssinaturaNovoContrato, setCnpjAssinaturaNovoContrato] = useState<string>("");

    // const [loading, setLoading] = useState(false);

    const [activeTab, setActiveTab] = useState('1');
    const [activeCustoTab, setActiveCustoTab] = useState<'custo' | 'financeiro'>('custo');
    const [showAllPhoneColumns, setShowAllPhoneColumns] = useState(false);
    const [expandedAlunoPhones, setExpandedAlunoPhones] = useState<Set<number>>(new Set());
    
    // Estados de loading específicos para cada aba do modal de edição
    const [loadingTab1, setLoadingTab1] = useState(false); // Dados do contrato
    const [loadingTab2, setLoadingTab2] = useState(false); // Alunos
    const [loadingTab3, setLoadingTab3] = useState(false); // Brindes/Solicitações
    const [loadingTab4, setLoadingTab4] = useState(false); // Eventos previstos
    const [loadingTab5, setLoadingTab5] = useState(false); // Observações
    
    // Controle de quais abas já foram carregadas
    const [loadedTabs, setLoadedTabs] = useState<Set<string>>(new Set(['1']));

    const [dataSearch, setDataSearch] = useState({ description: '', empresaId: 0, status: 0, city: '', state: '', region: '', isPrivate: '', vendedorId: 0, startDate: '', endDate: '', idContrato: 0, somenteKit: false });

    const [selectedAlunosIds, setSelectedAlunosIds] = useState<number[]>([]);
    const [selectedCursos, setSelectedCursos] = useState<CursoType[]>([]);

    const [currentView, setCurrentView] = useState<View>('month');
    const today = new Date();
    // const agendaBaseDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 365);
    const agendaBaseDate = useMemo(() => {
        if (customStartDate) {
            return moment(customStartDate).startOf("day").toDate();
        }
        if (listAgenda && listAgenda.length > 0) {
            const minStart = listAgenda.reduce((min, a) => {
                const d = new Date(a.startDate);
                return d < min ? d : min;
            }, new Date(listAgenda[0].startDate));

            return moment(minStart).startOf("day").toDate();
        }
        return moment().startOf("day").toDate();
    }, [customStartDate, listAgenda]);

    const [copyTransferModalOpen, setCopyTransferModalOpen] = useState(false);
    const [copyTransferMode, setCopyTransferMode] = useState<"copy" | "transfer">("copy");
    const [targetContratoId, setTargetContratoId] = useState<number>(0);
    const [targetCursoId, setTargetCursoId] = useState<number>(0);
    const [targetCursosList, setTargetCursosList] = useState<CursoType[]>([]);
    const [isTargetCursosLoading, setIsTargetCursosLoading] = useState(false);
    const [isCopyTransferLoading, setIsCopyTransferLoading] = useState(false);
    const [allContratosForModal, setAllContratosForModal] = useState<ContratoType[]>([]);

    const resetCopyTransferModal = () => {
        setCopyTransferMode("copy");
        setTargetContratoId(0);
        setTargetCursoId(0);
        setTargetCursosList([]);
        setIsTargetCursosLoading(false);
    };

    const formatCurrency = (value?: number) => (value ?? 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });

    const getCustoTotalValue = (individualValue?: number, currentBalance?: number, isFixo?: boolean) =>
        (Number(individualValue) || 0) * (isFixo ? (Number(currentBalance) || 0) : 1);

    const isTipoCustoFixo = (tipoCustoId?: number) =>
        listTipoCusto.find(tipo => Number(tipo.id) === Number(tipoCustoId))?.isFixo ?? false;

    const toggleAlunoPhones = (alunoId: number) => {
        setExpandedAlunoPhones(prev => {
            const next = new Set(prev);
            if (next.has(alunoId)) {
                next.delete(alunoId);
            } else {
                next.add(alunoId);
            }
            return next;
        });
    };

    const allVisibleAlunoDetailsExpanded = listAluno.length > 0 && listAluno.every(aluno => expandedAlunoPhones.has(aluno.id));

    const toggleAllVisibleAlunoDetails = () => {
        setExpandedAlunoPhones(prev => {
            if (allVisibleAlunoDetailsExpanded) {
                return new Set<number>();
            }

            return new Set([...Array.from(prev), ...listAluno.map(aluno => aluno.id)]);
        });
    };

    // Funções auxiliares para carregar dados SEM ativar o loading global
    const loadCursosByContratoId = async (contratoId: number) => {
        const response = await api.get(`/Curso/getCursosByContratoId?contratoId=${contratoId}`);
        setListCursoByContrato(response.data);
        return response.data;
    };

    const loadPreparacaoAlbum = async (pageNumber: number, empresaId: number, contratoId: number, pageSize: number) => {
        let url = `/PreparacaoAlbum/getPreparacaoAlbumPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (empresaId) url += `&EmpresaId=${empresaId}`;
        if (contratoId) url += `&ContratoId=${contratoId}`;
        
        const response = await api.get(url);
        setListPreparacaoAlbum(response.data.result);
        setPreparacaoAlbumPageCount(response.data.pageCount);
        return response.data;
    };

    const loadAlunos = async (pageNumber: number, contratoId: number, pageSize: number) => {
        let url = `/Aluno/getAlunoPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (contratoId) url += `&ContratoId=${contratoId}`;
        
        const response = await api.get(url);
        setListAluno(response.data.result);
        setAlunoPageCount(response.data.pageCount);
        setTotalAlunos(response.data.totalAlunos || 0);
        return response.data;
    };

    const loadCustos = async (pageNumber: number, contratoId: number, empresaId: number, pageSize: number) => {
        const [custoFinanceiro, custoGeral] = await Promise.all([
            getCustoFinanceiroPaged(pageNumber, contratoId, empresaId, pageSize),
            getCustoGeralPaged(pageNumber, contratoId, empresaId, pageSize)
        ]);

        return { custoFinanceiro, custoGeral };
    };

    const loadAgendas = async (empresaId: number, contratoId: number) => {
        const queryParams = new URLSearchParams({ empresaId: empresaId.toString() });
        if (contratoId) {
            queryParams.append("contratoId", contratoId.toString());
        }
        const response = await api.get(`/Agenda/list-all?${queryParams.toString()}`);
        setListAgenda(response.data);
        return response.data;
    };

    const loadObservacoes = async (pageNumber: number, pageSize: number, contratoId: number) => {
        const response = await api.get(`/ObservacaoContrato/getPaged?PageNumber=${pageNumber}&PageSize=${pageSize}&ContratoId=${contratoId}`);
        setListObservacaoContrato(response.data.result);
        setObservacaoContratoPageCount(response.data.pageCount);
        return response.data;
    };

    const toggleTab = async (tab: string) => {
        if (activeTab === tab) return;
        
        setActiveTab(tab);
        
        // Verifica se a aba já foi carregada
        if (loadedTabs.has(tab)) return;
        
        // Carrega dados específicos da aba sob demanda
        if (!selectedContratoId) return;
        
        try {
            switch (tab) {
                case '1': // Dados do contrato
                    setLoadingTab1(true);
                    await Promise.all([
                        loadCursosByContratoId(selectedContratoId),
                        loadPreparacaoAlbum(1, objUserTk.EmpresaId, selectedContratoId, 9)
                    ]);
                    setLoadingTab1(false);
                    break;
                    
                case '2': // Alunos
                    setLoadingTab2(true);
                    await loadAlunos(1, selectedContratoId, 9);
                    setLoadingTab2(false);
                    break;
                    
                case '3': // Brindes/Solicitações
                    setLoadingTab3(true);
                    await loadCustos(1, selectedContratoId, objUserTk.EmpresaId, 9);
                    setLoadingTab3(false);
                    break;
                    
                case '4': // Eventos previstos
                    setLoadingTab4(true);
                    await loadAgendas(objUserTk.EmpresaId, selectedContratoId);
                    setLoadingTab4(false);
                    break;
                    
                case '5': // Observações
                    setLoadingTab5(true);
                    await loadObservacoes(1, 9, selectedContratoId);
                    setLoadingTab5(false);
                    break;
            }
            
            // Marca a aba como carregada
            setLoadedTabs(prev => new Set([...Array.from(prev), tab]));
        } catch (error) {
            console.error(`Erro ao carregar dados da aba ${tab}:`, error);
            // Reseta o loading em caso de erro
            setLoadingTab1(false);
            setLoadingTab2(false);
            setLoadingTab3(false);
            setLoadingTab4(false);
            setLoadingTab5(false);
        }
    };

    // useEffect(() => {
    //     setLoading(true);

    //     handleGetInstituicaoByEmpresaId(objUserTk.EmpresaId);
    //     handleGetCursoByEmpresaId(objUserTk.EmpresaId);
    //     handleGetVendedoresByEmpresa(objUserTk.EmpresaId);
    //     handleGetRepresentanteComercialByEmpresa(objUserTk.EmpresaId);
    //     getAllTipoCustoPaged(1, 100, objUserTk.EmpresaId);
    //     getAllTipoAgendaPaged(1, 100, objUserTk.EmpresaId);

    //     getTerceiroPaged(1, "", objUserTk.EmpresaId, 1000, "Fotógrafo");
    //     handleGetEditorsByEmpresa(objUserTk.EmpresaId);
    //     handleGetLaboratoriesByEmpresa(objUserTk.EmpresaId);

    //     getAllContratoPaged(1, 9, "", objUserTk.EmpresaId)
    //         .then(data => {
    //             setLoading(false);
    //         })
    //         .catch(error => {
    //             console.error("Erro ao buscar contratos:", error);
    //             setLoading(false);
    //         });
    // }, []);

    useEffect(() => {
        let alive = true;

        (async () => {
            try {
                // Paraleliza todas as chamadas de API independentes para melhorar performance
                await Promise.all([
                    handleGetInstituicaoByEmpresaId(objUserTk.EmpresaId),
                    handleGetCursoByEmpresaId(objUserTk.EmpresaId),
                    handleGetVendedoresByEmpresa(objUserTk.EmpresaId),
                    handleGetRepresentanteComercialByEmpresa(objUserTk.EmpresaId),
                    getAllTipoCustoPaged(1, 100, objUserTk.EmpresaId),
                    getAllTipoAgendaPaged(1, 100, objUserTk.EmpresaId),
                    getTerceiroPaged(1, "", objUserTk.EmpresaId, 1000, "Fotógrafo"),
                    handleGetEditorsByEmpresa(objUserTk.EmpresaId),
                    handleGetLaboratoriesByEmpresa(objUserTk.EmpresaId),
                ]);

                if (!alive) return;

                // Busca contratos por último, após os dados de suporte estarem carregados
                await getAllContratoPaged(1, 9, "", objUserTk.EmpresaId);
            } catch (e) {
                console.error("Erro no bootstrap da tela de contratos:", e);
            }
        })();

        return () => {
            alive = false;
        };
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    // Limpa dados ao trocar de contrato para evitar mostrar dados do contrato anterior
    useEffect(() => {
        if (selectedContratoId > 0) {
            // Limpa as listas para forçar carregamento dos novos dados
            setListAluno([]);
            setListCursoByContrato([]);
        }
    }, [selectedContratoId]);

    useEffect(() => {
        if (selectedInstituicaoId > 0) {
            const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
            getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
            handleGetResponsavelByInstituicaoId(selectedInstituicaoId);
        }
    }, [selectedInstituicaoId]);

    useEffect(() => {
        if (newCusto.tipoCustoId > 0) {
            const saldo =
                newContrato.currentStudents && newContrato.currentStudents > 0
                    ? newContrato.currentStudents
                    : newContrato.hiredStudents && newContrato.hiredStudents > 0
                        ? newContrato.hiredStudents
                        : 0;

            setNewCusto(prev => ({
                ...prev,
                currentBalance: saldo,
            }));
        }
    }, [newContrato.currentStudents, newContrato.hiredStudents]);

    useEffect(() => {
        const controller = new AbortController();
        const t = setTimeout(async () => {
            const q = (dataSearch.description || "").trim();
            if (!q) {
                setDescSuggestions([]);
                return;
            }
            try {
                setIsLoadingDesc(true);
                const items = await suggestContratoDescriptions(q, 10);
                setDescSuggestions(items);
            } catch (e) {
                console.error(e);
                setDescSuggestions([]);
            } finally {
                setIsLoadingDesc(false);
            }
        }, 400); // Aumentado de 200ms para 400ms para reduzir chamadas à API

        return () => {
            clearTimeout(t);
            controller.abort();
        };
    }, [dataSearch.description]);

    useEffect(() => {
        if (editModalOpen) {
            setSelectedAlunosIds([]);
        } else if (!editModalOpen && selectedContratoId > 0) {
            // Limpa os dados quando o modal é fechado para evitar cache entre contratos
            setSelectedContratoId(0);
            setListAluno([]);
            setListCursoByContrato([]);
            setSelectedCursoFiltroAlunos(null);
            setReferenceCodeFiltroAlunos('');
            // Reseta os estados de loading e abas carregadas
            setLoadingTab1(false);
            setLoadingTab2(false);
            setLoadingTab3(false);
            setLoadingTab4(false);
            setLoadingTab5(false);
            setLoadedTabs(new Set(['1']));
            setActiveTab('1');
        }
    }, [editModalOpen]);

    useEffect(() => {
        if (selectedContratoId <= 0) return;

        const parsed = parseInt(referenceCodeFiltroAlunos, 10);
        const referenceCode = isNaN(parsed) ? undefined : parsed;

        const timer = setTimeout(() => {
            getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, referenceCode);
        }, 400);

        return () => clearTimeout(timer);
    }, [referenceCodeFiltroAlunos, selectedCursoFiltroAlunos, selectedContratoId]);

    useEffect(() => {
        if (createModalOpen) {
            setSelectedAlunosIds([]);
            setCnpjAssinaturaNovoContrato("");
            getFlashCnpjs().then(setFlashCnpjs).catch((error) => {
                console.error("Erro ao buscar CNPJs da Flash:", error);
            });
        }
    }, [createModalOpen]);

    //--------------------------------------------

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllContratoPaged(value, 9, dataSearch.description, objUserTk.EmpresaId, dataSearch.status, dataSearch.city, dataSearch.startDate, dataSearch.endDate, dataSearch.idContrato, dataSearch.state, dataSearch.region, dataSearch.isPrivate === '' ? undefined : dataSearch.isPrivate === 'true', dataSearch.vendedorId || undefined, dataSearch.somenteKit || undefined);
    };

    const onChangePaginationAluno = async (e: any, value: any) => {
        const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
        await getAlunoPaged(value, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
    };

    const onChangePaginationCustoFinanceiro = async (e: any, value: any) => {
        await getCustoFinanceiroPaged(value, selectedContratoId, objUserTk.EmpresaId, 9);
    }

    const onChangePaginationCustoGeral = async (e: any, value: any) => {
        await getCustoGeralPaged(value, selectedContratoId, objUserTk.EmpresaId, 9);
    }

    const onChangePaginationPreparacaoAlbum = async (e: any, value: any) => {
        await getPreparacaoAlbumPaged(value, objUserTk.EmpresaId, selectedContratoId, 9);
    }

    const onChangePaginationObservacaoContrato = async (e: any, value: any) => {
        await getObservacaoContratoPaged(value, 9, selectedContratoId);
    }

    //--------------------------------------------

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, description: e.target.value });
    };

    const handleSearchButtonClick = () => {
        getAllContratoPaged(1, 9, dataSearch.description, objUserTk.EmpresaId, dataSearch.status, dataSearch.city, dataSearch.startDate, dataSearch.endDate, dataSearch.idContrato, dataSearch.state, dataSearch.region, dataSearch.isPrivate === '' ? undefined : dataSearch.isPrivate === 'true', dataSearch.vendedorId || undefined, dataSearch.somenteKit || undefined)
    };

    const handleClearFilters = () => {
        setDataSearch({ description: '', empresaId: 0, status: 0, city: '', state: '', region: '', isPrivate: '', vendedorId: 0, startDate: '', endDate: '', idContrato: 0, somenteKit: false });
        getAllContratoPaged(1, 9, "", objUserTk.EmpresaId)
    };

    //--------------------------------------------

    const handleInstituicaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const instituicaoId = Number(e.target.value);
        setSelectedInstituicaoId(instituicaoId);
        setNewContrato(prev => ({ ...prev, instituicaoId }));
    };

    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setNewContrato(prevContrato => ({
                    ...prevContrato,
                    contractAnnex: reader.result as string,
                }));
            };
            reader.onerror = (error) => {
                console.error("Erro ao ler arquivo:", error);
            };
        }
    };

    const handleEditFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setEditingContrato(prevContrato => ({
                    ...prevContrato!,
                    contractAnnex: reader.result as string,
                }));
            };
            reader.onerror = (error) => {
                console.error("Erro ao ler arquivo:", error);
            };
        }
    };

    const formatContratoData = (contrato: any) => ({
        ...contrato,
        hiredStudents: contrato.hiredStudents ? Number(contrato.hiredStudents) : null,
        currentStudents: contrato.currentStudents ? Number(contrato.currentStudents) : null,
        totalValue: contrato.totalValue !== undefined && contrato.totalValue !== null && contrato.totalValue !== '' ? Number(contrato.totalValue) : null,
        downPaymentValue: contrato.downPaymentValue !== undefined && contrato.downPaymentValue !== null && contrato.downPaymentValue !== '' ? Number(contrato.downPaymentValue) : null,
        installmentValue: contrato.installmentValue !== undefined && contrato.installmentValue !== null && contrato.installmentValue !== '' ? Number(contrato.installmentValue) : null,
        installmentsCount: contrato.installmentsCount !== undefined && contrato.installmentsCount !== null && contrato.installmentsCount !== '' ? Number(contrato.installmentsCount) : null,
        paymentDueDay: contrato.paymentDueDay !== undefined && contrato.paymentDueDay !== null && contrato.paymentDueDay !== '' ? Number(contrato.paymentDueDay) : null,
        empresaId: Number(contrato.empresaId),
        instituicaoId: Number(contrato.instituicaoId),
        linkSent: contrato.linkSent === "true" || contrato.linkSent === true,
        freebies: contrato.freebies === "true" || contrato.freebies === true,
        completionDate: contrato.completionDate ? contrato.completionDate : null,
        dateOfDischarge: contrato.dateOfDischarge ? contrato.dateOfDischarge : null,
        status: Number(contrato.status),
        vendedorId: Number(contrato.vendedorId),
        cursoId: selectedCursos.map((curso) => curso.id),
        alunoId: selectedAlunosIds,
    });

    const formatCustoData = (custo: any) => ({
        ...custo,
        individualValue: Number(custo.individualValue),
        currentBalance: Number(custo.currentBalance),
        requestDate: custo.requestDate ? custo.requestDate : null,
        deliveryDate: custo.deliveryDate ? custo.deliveryDate : null,
        paymentDate: custo.paymentDate ? custo.paymentDate : null,
        isPaid: custo.isPaid === "true" || custo.isPaid === true,
        empresaId: Number(custo.empresaId),
        contratoId: Number(custo.contratoId),
        tipoCustoId: Number(custo.tipoCustoId),
    });

    const formatPreparacaoAlbumData = (preparacaoAlbum: any) => ({
        ...preparacaoAlbum,
        numberOfPhotos: Number(preparacaoAlbum.numberOfPhotos),
        numberOfAlbums: Number(preparacaoAlbum.numberOfAlbums),
        numberOfPhotosLaboratory: Number(preparacaoAlbum.numberOfPhotosLaboratory),
        editorDeliveryDate: preparacaoAlbum.editorDeliveryDate ? preparacaoAlbum.editorDeliveryDate : null,
        editorReturnDate: preparacaoAlbum.editorReturnDate ? preparacaoAlbum.editorReturnDate : null,
        laboratoryDeliveryDate: preparacaoAlbum.laboratoryDeliveryDate ? preparacaoAlbum.laboratoryDeliveryDate : null,
        laboratoryReturnDate: preparacaoAlbum.laboratoryReturnDate ? preparacaoAlbum.laboratoryReturnDate : null,
        kit30x60: preparacaoAlbum.kit30x60,
        kit30x60Quantities: preparacaoAlbum.kit30x60Quantities,
        kit10x15: preparacaoAlbum.kit10x15,
        kit10x15Quantities: preparacaoAlbum.kit10x15Quantities,
        kit28x35: preparacaoAlbum.kit28x35,
        kit28x35Quantities: preparacaoAlbum.kit28x35Quantities,
        empresaId: Number(preparacaoAlbum.empresaId),
        contratoId: Number(preparacaoAlbum.contratoId),
        editorId: Number(preparacaoAlbum.editorId),
        laboratorioId: Number(preparacaoAlbum.laboratorioId),
        cursoId: listCursoByContrato.map((curso) => curso.id),
    });

    const handleCreateContrato = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const formattedContrato = formatContratoData(newContrato);
            const cretedContrato = await createContrato(formattedContrato);

            if (cretedContrato) {

                custos.forEach(async (custo) => {

                    const formattedCusto = formatCustoData(custo);
                    await createCusto({ ...formattedCusto, contratoId: Number(cretedContrato), empresaId: objUserTk.EmpresaId });
                });

                if (cnpjAssinaturaNovoContrato) {
                    setAssinaturaLoading(true);
                    try {
                        await enviarParaAssinatura(Number(cretedContrato), cnpjAssinaturaNovoContrato);
                    } catch (error) {
                        console.error("Erro ao enviar contrato para assinatura digital:", error);
                    } finally {
                        setAssinaturaLoading(false);
                    }
                }

                getAllContratoPaged(1, 9, "", objUserTk.EmpresaId);
                setCreateModalOpen(false);
            }
        }
        catch (error) {
            console.error("Erro ao criar contrato:", error);
        }
    }

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewContrato(prevContrato => ({
                ...prevContrato,
                [name]: checked,
            }));
        } else {
            setNewContrato(prevContrato => ({
                ...prevContrato,
                [name]: value === '' ? null : value
            }));
        }
    };

    //FUNÇÕES AUXILIARES AO MODAL DE CRIAÇÃO DE CONTRATO------------------------

    const handleCreateCustoInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewCusto(prevCusto => ({
                ...prevCusto,
                [name]: checked,
            }));
        } else {
            setNewCusto(prevCusto => ({
                ...prevCusto,
                [name]: value === '' ? null : value
            }));
        }
    };

    const handleEnviarParaFinanceiro = async (custoId: number) => {
        const success = await enviarCustoParaFinanceiro(custoId);
        if (success) {
            await getCustoFinanceiroPaged(1, selectedContratoId, objUserTk.EmpresaId, 9);
            await getCustoGeralPaged(1, selectedContratoId, objUserTk.EmpresaId, 9);
        }
    };

    //------------------------------------------------------------------------------

    const handleCreatePreparacaoAlbum = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formattedData = formatPreparacaoAlbumData(newPreparacaoAlbum);

        createPreparacaoAlbum(formattedData)
            .then(createdPreparacaoAlbum => {
                if (createdPreparacaoAlbum) {
                    setNewPreparacaoAlbum({
                        description: "",
                        numberOfPhotos: 0,
                        numberOfPhotosLaboratory: 0,
                        numberOfAlbums: 0,
                        editorDeliveryDate: "",
                        editorReturnDate: "",
                        laboratoryDeliveryDate: "",
                        laboratoryReturnDate: "",
                        kit30x60: false,
                        kit30x60Quantities: 0,
                        kit10x15: false,
                        kit10x15Quantities: 0,
                        kit28x35: false,
                        kit28x35Quantities: 0,
                        empresaId: Number(objUserTk.EmpresaId),
                        contratoId: selectedContratoId,
                        editorId: 0,
                        laboratorioId: 0,
                        cursoId: []
                    });
                    getPreparacaoAlbumPaged(1, objUserTk.EmpresaId, selectedContratoId, 9);
                    handleGetCursoByContratoId(selectedContratoId);
                    getAllContratoPaged(1, 9, "", objUserTk.EmpresaId);
                } else {
                    console.error("Erro ao criar preparação de álbum.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar preparação de álbum:", error);
            })
    };

    const handleCreatePreparacaoAlbumInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setNewPreparacaoAlbum(prevPreparacaoAlbum => ({
            ...prevPreparacaoAlbum,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleCreateObservacaoContratoInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewObservacaoContrato(prevObservacaoContrato => ({
                ...prevObservacaoContrato,
                [name]: checked,
            }));
        } else {
            setNewObservacaoContrato(prevObservacaoContrato => ({
                ...prevObservacaoContrato,
                [name]: value,
            }));
        }
    };

    const handleCreateObservacaoContrato = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formattedData = {
            ...newObservacaoContrato,
            date: newObservacaoContrato.date || new Date().toISOString().split('T')[0],
            contratoId: selectedContratoId,
        };

        createObservacaoContrato(formattedData)
            .then(createdObservacaoContrato => {
                if (createdObservacaoContrato) {
                    setCreateObservacaoContratoModalOpen(false);
                    setNewObservacaoContrato({
                        observation: "",
                        date: "",
                        contratoId: selectedContratoId,
                    });
                    getObservacaoContratoPaged(1, 9, selectedContratoId);
                } else {
                    console.error("Erro ao observação agenda.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar observação:", error);
            });
    };

    //--------------------------------------------

    const handleEditContrato = async (contrato: ContratoType) => {
        setSelectedAlunosIds([]);
        setSelectedFields([]);

        // Limpa dados antigos ANTES de carregar os novos
        setListAluno([]);
        setListCursoByContrato([]);

        setEditingContrato(contrato);
        setSelectedContratoId(contrato.id);
        
        // Reseta o controle de abas carregadas
        setLoadedTabs(new Set(['1']));
        setActiveTab('1');
        
        // ABRE O MODAL IMEDIATAMENTE
        setEditModalOpen(true);
        
        // Carrega os dados da primeira aba COM loading APENAS do modal (SEM loading global)
        setLoadingTab1(true);
        try {
            await Promise.all([
                loadCursosByContratoId(contrato.id),
                loadPreparacaoAlbum(1, objUserTk.EmpresaId, contrato.id, 9),
            ]);
        } catch (error) {
            console.error("Erro ao carregar dados do contrato:", error);
        } finally {
            setLoadingTab1(false);
        }
    };

    const refreshAgenda = async () => {
        if (!selectedContratoId) return;
        await listAllAgenda(objUserTk.EmpresaId, selectedContratoId);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingContrato) {
            const updatedData = {
                ...editingContrato,
            };

            updateContrato(updatedData)
                .then(async updatedContrato => {
                    if (updatedContrato) {
                        // Recarrega os custos para refletir o saldo recalculado a partir
                        // de "Alunos atuais" antes de fechar o modal.
                        if (selectedContratoId > 0) {
                            await loadCustos(1, selectedContratoId, objUserTk.EmpresaId, 9);
                        }
                        setEditModalOpen(false);
                        setEditingContrato(null);
                        setSelectedContratoId(0);
                        // Limpa dados do contrato anterior
                        setListAluno([]);
                        setListCursoByContrato([]);
                        getAllContratoPaged(1, 9, "", objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao atualizar contrato.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar contrato:", error);
                });
        }
    };

    const handleEditAluno = (aluno: AlunoType) => {
        setEditingAluno(aluno);
        setEditAlunoModalOpen(true);
    };

    const handleEditAgenda = (agenda: AgendaType) => {
        const updateData: EditAgendaType = {
            id: agenda.id,
            description: agenda.description,
            location: agenda.location,
            responsible: agenda.responsible,
            startDate: agenda.startDate,
            endDate: agenda.endDate,
            // cursoId: agenda.cursoId,
            cursoId: agenda.cursoId || 0,
            cursoName: agenda.cursoName || "",
            cursoIds: agenda.cursoIds || [],
            cursoNames: agenda.cursoNames || [],
            beca: agenda.beca,
            step: agenda.step,
            tipoAgendaId: agenda.tipoAgendaId,
        };
        setEditingAgenda(updateData);
        handleGetTerceiroByAgendaId(agenda.id);
        setEditAgendaModalOpen(true);
    };

    const handleEditPreparacaoAlbumInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        serEditingPreparacaoAlbum(prevPreparacaoAlbum => ({
            ...prevPreparacaoAlbum!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleEditPreparacaoAlbum = (preparacaoAlbum: PreparacaoAlbumType) => {
        serEditingPreparacaoAlbum({
            ...preparacaoAlbum,
            contratoId: preparacaoAlbum.contratoId || selectedContratoId,
        });
        setEditPreparacaoAlbumModalOpen(true);
    };

    const handleEditPreparacaoAlbumSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (editingPreparacaoAlbum) {

            const updatedData: EditPreparacaoAlbumType = {
                ...editingPreparacaoAlbum,
            };

            updatePreparacaoAlbum(updatedData)
                .then(updatedPreparacaoAlbum => {
                    if (updatedPreparacaoAlbum) {
                        setEditPreparacaoAlbumModalOpen(false);
                        getPreparacaoAlbumPaged(1, objUserTk.EmpresaId, selectedContratoId, 9);
                        getAllContratoPaged(1, 9, "", objUserTk.EmpresaId);
                        serEditingPreparacaoAlbum(null);
                    } else {
                        console.error("Erro ao atualizar preparação de álbum.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar preparação de álbum:", error);
                });
        }
    };

    const handleEditObservacaoContratoInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setEditingObservacaoContrato(prevObservacaoContrato => ({
            ...prevObservacaoContrato!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleEditObservacaoContrato = (observacaoContrato: ObservacaoContratoType) => {
        setEditingObservacaoContrato({
            ...observacaoContrato
        });
        setEditObservacaoContratoModalOpen(true);
    };

    const handleEditObservacaoContratoSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!editingObservacaoContrato?.id) {
            console.error("Error: Observação Contrato ID é indefinido.");
            return;
        }

        const updatedData: EditObservacaoContratoType = {
            ...editingObservacaoContrato,
            id: editingObservacaoContrato.id,
        };

        updateObservacaoContrato(updatedData)
            .then(updatedObservacaoContrato => {
                if (updatedObservacaoContrato) {
                    setEditObservacaoContratoModalOpen(false);
                    getObservacaoContratoPaged(1, 9, selectedContratoId);
                    setEditingObservacaoContrato(null);
                } else {
                    console.error("Erro ao atualizar observação.");
                }
            })
            .catch(error => {
                console.error("Erro ao atualizar observação:", error);
            });
    };

    //--------------------------------------------

    const handleAddCusto = () => {
        setCustos([...custos, { ...newCusto }]);
        setNewCusto({
            description: '',
            proportionalCurrentStudents: false,
            individualValue: 0,
            // currentBalance: 0,
            requestDate: '',
            deliveryDate: '',
            paymentDate: '',
            receiver: '',
            observation: '',
            isPaid: false,
            empresaId: objUserTk.EmpresaId,
            contratoId: selectedContratoId,
            tipoCustoId: 0,
        });
    };

    const handleRemoveCusto = (index: number) => {
        setCustos(custos.filter((_, i) => i !== index));
    };

    //--------------------------------------------

    const handleDeleteContrato = (contratoId: number) => {
        setPendingDelete({
            type: "contrato",
            ids: { contratoId },
            force: false,
            title: "Excluir contrato",
            message: "Você realmente deseja excluir este contrato? Esta ação não pode ser desfeita.",
        });
    };

    const abrirStatusAssinatura = async (contratoId: number) => {
        setAssinaturaContratoId(contratoId);
        setAssinaturaModalOpen(true);
        setAssinaturaLoading(true);
        try {
            const status = await getStatusAssinatura(contratoId);
            setAssinaturaStatus(status);
        } finally {
            setAssinaturaLoading(false);
        }
    };

    const atualizarStatusAssinatura = async () => {
        if (assinaturaContratoId == null) return;
        setAssinaturaLoading(true);
        try {
            const status = await getStatusAssinatura(assinaturaContratoId);
            setAssinaturaStatus(status);
        } finally {
            setAssinaturaLoading(false);
        }
    };

    const fecharModalAssinatura = () => {
        setAssinaturaModalOpen(false);
        setAssinaturaContratoId(null);
        setAssinaturaStatus(null);
    };

    useEffect(() => {
        if (!assinaturaModalOpen || assinaturaContratoId == null) return;
        const status = assinaturaStatus?.status;
        const emAndamento = status !== undefined && [1, 2, 3, 4].includes(status);
        if (!emAndamento) return;

        const interval = setInterval(() => {
            getStatusAssinatura(assinaturaContratoId).then((s) => {
                if (s) setAssinaturaStatus(s);
            });
        }, 15000);
        return () => clearInterval(interval);
    }, [assinaturaModalOpen, assinaturaContratoId, assinaturaStatus?.status, getStatusAssinatura]);

    const getAssinaturaBadgeColor = (status?: number): string => {
        switch (status) {
            case 5:
            case 7:
                return "success";
            case 8:
            case 6:
                return "danger";
            case 3:
            case 4:
                return "info";
            default:
                return "secondary";
        }
    };

    const handleDeleteAluno = (alunoId: number) => {
        if (!selectedContratoId) {
            showToast("error", "Selecione um contrato antes.");
            return;
        }

        setPendingDelete({
            type: "aluno",
            ids: { alunoId },
            force: false,
            title: "Excluir aluno",
            message: "O aluno será excluído permanentemente do sistema. Esta ação não pode ser desfeita.",
        });
    };

    const handleRemoveAlunoFromContrato = (alunoId: number, cursoId: number) => {
        if (!selectedContratoId) {
            showToast("error", "Selecione um contrato antes.");
            return;
        }

        setPendingDelete({
            type: "removeAlunoFromContrato",
            ids: { alunoId, cursoId },
            force: false,
            title: "Remover vínculo deste curso",
            message: "Apenas o vínculo do aluno com este curso do contrato será removido. O aluno permanece cadastrado no sistema.",
        });
    };

    const handleDeleteCusto = (custoId: number) => {
        setPendingDelete({
            type: "custo",
            ids: { custoId },
            force: false,
            title: "Excluir custo",
            message: "Tem certeza que deseja excluir este custo? Esta ação não pode ser desfeita.",
        });
    };

    const handleDeleteAgenda = (agendaId: number) => {
        if (!selectedContratoId) return;

        setPendingDelete({
            type: "agenda",
            ids: { agendaId },
            force: false,
            title: "Excluir agenda",
            message: "Tem certeza que deseja excluir esta agenda? Esta ação não pode ser desfeita.",
        });
    };

    const handleDeletePreparacaoAlbum = (preparacaoAlbumId: number) => {
        setPendingDelete({
            type: "preparacaoAlbum",
            ids: { preparacaoAlbumId },
            force: false,
            title: "Excluir preparação de álbum",
            message: "Tem certeza que deseja excluir esta preparação de álbum? Esta ação não pode ser desfeita.",
        });
    };

    const handleDeleteObservacaoContrato = (observacaoContratoId: number) => {
        setPendingDelete({
            type: "observacaoContrato",
            ids: { observacaoContratoId },
            force: false,
            title: "Excluir observação",
            message: "Tem certeza que deseja excluir esta observação? Esta ação não pode ser desfeita.",
        });
    };

    const executeDelete = async () => {
        if (!pendingDelete) return;
        setDeleteLoading(true);

        try {
            switch (pendingDelete.type) {
                case "contrato": {
                    const result = await deleteContrato(pendingDelete.ids.contratoId, pendingDelete.force);
                    if (result.status === "ok") {
                        getAllContratoPaged(1, 9, "", objUserTk.EmpresaId);
                        closeDeleteModal();
                    } else if (result.status === "conflict") {
                        showToast("error", `${result.message} (${formatDependentes(result.dependentes)})`);
                        setPendingDelete({ ...pendingDelete, force: true });
                        setDeleteLoading(false);
                    } else {
                        closeDeleteModal();
                    }
                    break;
                }
                case "aluno": {
                    const result = await deleteAluno(pendingDelete.ids.alunoId, pendingDelete.force);
                    if (result.status === "ok") {
                        const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
                        getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
                        setSelectedAlunosIds((prev) => prev.filter((id) => id !== pendingDelete.ids.alunoId));
                        closeDeleteModal();
                    } else if (result.status === "conflict") {
                        showToast("error", `${result.message} (${formatDependentes(result.dependentes)})`);
                        setPendingDelete({ ...pendingDelete, force: true });
                        setDeleteLoading(false);
                    } else {
                        closeDeleteModal();
                    }
                    break;
                }
                case "removeAlunoFromContrato": {
                    if (!selectedContratoId) { closeDeleteModal(); break; }
                    const removed = await removeAlunoFromContrato(selectedContratoId, pendingDelete.ids.alunoId, pendingDelete.ids.cursoId);
                    if (removed) {
                        const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
                        getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
                        setSelectedAlunosIds((prev) => prev.filter((id) => id !== pendingDelete.ids.alunoId));
                    }
                    closeDeleteModal();
                    break;
                }
                case "custo": {
                    const deletedCusto = await deleteCusto(pendingDelete.ids.custoId);
                    if (!deletedCusto) console.error("Erro ao excluir custo.");
                    getCustoFinanceiroPaged(1, selectedContratoId, objUserTk.EmpresaId, 9);
                    getCustoGeralPaged(1, selectedContratoId, objUserTk.EmpresaId, 9);
                    closeDeleteModal();
                    break;
                }
                case "agenda": {
                    await deleteAgenda(pendingDelete.ids.agendaId);
                    await refreshAgenda();
                    setEditAgendaModalOpen(false);
                    closeDeleteModal();
                    break;
                }
                case "preparacaoAlbum": {
                    await deletePreparacaoAlbum(pendingDelete.ids.preparacaoAlbumId);
                    setTimeout(() => {
                        getPreparacaoAlbumPaged(1, objUserTk.EmpresaId, selectedContratoId, 9);
                        getAllContratoPaged(1, 9, "", objUserTk.EmpresaId);
                        setEditPreparacaoAlbumModalOpen(false);
                    }, 500);
                    closeDeleteModal();
                    break;
                }
                case "observacaoContrato": {
                    await deleteObservacaoContrato(pendingDelete.ids.observacaoContratoId);
                    setTimeout(() => {
                        getObservacaoContratoPaged(1, 9, selectedContratoId);
                        setEditObservacaoContratoModalOpen(false);
                    }, 500);
                    closeDeleteModal();
                    break;
                }
                case "removerCursoDoContrato": {
                    if (!editingContrato) { closeDeleteModal(); break; }
                    setIsSyncingCursos(true);
                    const result = await removeCursoDoContrato(editingContrato.id, pendingDelete.ids.cursoId, pendingDelete.force);
                    setIsSyncingCursos(false);
                    if (result.status === "ok") {
                        const novaLista = listCursoByContrato.filter(c => c.id !== pendingDelete.ids.cursoId);
                        setListCursoByContrato(novaLista);
                        await handleGetCursoByContratoId(editingContrato.id);
                        closeDeleteModal();
                    } else if (result.status === "conflict") {
                        showToast("error", `${result.message} (${formatDependentes(result.dependentes)})`);
                        setPendingDelete({ ...pendingDelete, force: true });
                        setDeleteLoading(false);
                    } else {
                        closeDeleteModal();
                    }
                    break;
                }
            }
        } catch (error) {
            console.error("Erro ao excluir:", error);
            setDeleteLoading(false);
        }
    };

    //--------------------------------------------

    const handleCursoSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
        const cursoId = Number(event.target.value);
        const cursoSelecionado = listCurso.find((curso) => curso.id === cursoId);

        if (!cursoSelecionado) return;

        setSelectedCursos((prevCursos) => {
            const isAlreadySelected = prevCursos.some((curso) => curso.id === cursoId);

            if (isAlreadySelected) {
                return prevCursos.filter((curso) => curso.id !== cursoId);
            } else {
                return [...prevCursos, cursoSelecionado];
            }
        });
    };

    const handleAlunoSelection = (alunoId: number) => {
        setSelectedAlunosIds(prevIds =>
            prevIds.includes(alunoId)
                ? prevIds.filter(id => id !== alunoId)
                : [...prevIds, alunoId]
        );
    };

    const handleTerceiroSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
        const terceiroId = Number(event.target.value);
        const terceiroSelecionado = listTerceiro.find((terceiro) => terceiro.id === terceiroId);

        if (!terceiroSelecionado) return;

        setSelectedTerceiros((prevAgenda) => {
            const isAlreadySelected = prevAgenda.some((terceiro) => terceiro.id === terceiroId);

            if (isAlreadySelected) {
                return prevAgenda.filter((terceiro) => terceiro.id !== terceiroId);
            } else {
                return [...prevAgenda, terceiroSelecionado];
            }
        });
    };

    //--------------------------------------------

    const resetFormState = () => {
        setNewContrato({
            description: '',
            contractAnnex: '',
            class: '',
            hiredStudents: 0,
            currentStudents: 0,
            completionDate: '',
            dateOfDischarge: '',
            linkSent: false,
            freebies: false,
            empresaId: objUserTk.EmpresaId,
            instituicaoId: 0,
            cursoId: [],
            vendedorId: 0,
            alunoId: [],
            status: 0,
        });
        setNewCusto({
            description: '',
            proportionalCurrentStudents: false,
            individualValue: 0,
            currentBalance: 0,
            requestDate: '',
            deliveryDate: '',
            paymentDate: '',
            receiver: '',
            observation: '',
            isPaid: false,
            empresaId: objUserTk.EmpresaId,
            contratoId: selectedContratoId,
            tipoCustoId: 0,
        });
        setCustos([]);
        setSelectedCursos([]);
        setSelectedAlunosIds([]);
        setListAluno([]);
    };

    //--------------------------------------------

    const handleCopyLink = async (contratoId: number) => {
        try {
            const encryptedContratoId = await encryptId(contratoId);
            const url = `${window.location.origin}/cadastro-aluno/${encryptedContratoId}`;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(url);
                showToast("success", "Link copiado com sucesso.");
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = url;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);

                showToast("success", "Link copiado com sucesso.");
            }
        } catch (error) {
            console.error("Erro ao copiar link:", error);
            showToast("error", "Erro ao copiar link. Verifique as permissões do navegador.");
        }
    };


    //--------------------------------------------

    const handleSelectSlot = (slotInfo: SlotInfo) => {
        setSlotStart(moment(slotInfo.start).format('YYYY-MM-DDTHH:mm'));
        setSlotEnd(moment(slotInfo.end).format('YYYY-MM-DDTHH:mm'));
        setCreateAgendaModalOpen(true);
    };

    const handleSelectEvent = (event: any, e: React.SyntheticEvent<HTMLElement>) => {
        e.preventDefault();
        const agenda = listAgenda.find(a => a.id === event.id);
        if (agenda) {
            handleEditAgenda(agenda);
        }
    };

    const handleEventDrop = async (args: EventInteractionArgs<any>) => {
        const { event, start, end } = args;

        const updatedAgenda = listAgenda.find(a => a.id === event.id);
        if (!updatedAgenda) return;

        await updateAgenda({
            ...updatedAgenda,
            startDate: moment(start).format('YYYY-MM-DDTHH:mm'),
            endDate: moment(end).format('YYYY-MM-DDTHH:mm'),
        });

        await refreshAgenda();
    };

    const events = listAgenda.map((agenda: AgendaType) => ({
        id: agenda.id,
        title: agenda.description,
        start: new Date(agenda.startDate),
        end: new Date(agenda.endDate),
        cursoName: agenda.cursoName ?? "-",
    }));

    const CustomAgendaEvent = ({ event }: { event: any }) => (
        <div>
            <div><strong>{event.title}</strong></div>
            <div><small><strong>Curso:</strong> {event.cursoName}</small></div>
        </div>
    );

    const handleMultiSelectChange = (selected: any) =>
        setSelectedAgendaIds(selected ? selected.map((o: any) => o.value) : []);

    const handleDownloadPdf = () => {
        const filtrosVazios =
            !customStartDate &&
            !customEndDate &&
            (!selectedAgendaIds || selectedAgendaIds.length === 0);

        if (filtrosVazios) {
            downloadAgendaPdfCustom({
                empresaId: objUserTk.EmpresaId,
                startDate: undefined,
                endDate: undefined,
                agendaIds: undefined,
                contratoId: selectedContratoId,
            });
        } else {
            downloadAgendaPdfCustom({
                empresaId: objUserTk.EmpresaId,
                startDate: customStartDate || undefined,
                endDate: customEndDate || undefined,
                agendaIds: selectedAgendaIds.length > 0 ? selectedAgendaIds : undefined,
                contratoId: selectedContratoId,
            });
        }
    };

    const handlePrintPdf = () => {
        const filtrosVazios =
            !customStartDate &&
            !customEndDate &&
            (!selectedAgendaIds || selectedAgendaIds.length === 0);

        if (filtrosVazios) {
            printAgendaPdfCustom({
                empresaId: objUserTk.EmpresaId,
                startDate: undefined,
                endDate: undefined,
                agendaIds: undefined,
                contratoId: selectedContratoId,
            });
        } else {
            printAgendaPdfCustom({
                empresaId: objUserTk.EmpresaId,
                startDate: customStartDate || undefined,
                endDate: customEndDate || undefined,
                agendaIds: selectedAgendaIds.length > 0 ? selectedAgendaIds : undefined,
                contratoId: selectedContratoId,
            });
        }
    };

    //--------------------------------------------

    const handleFieldSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fieldValue = event.target.value;
        const fieldObj = RELATORIO_FIELDS.find(f => f.value === fieldValue);
        if (!fieldObj) return;

        setSelectedFields(prev =>
            prev.includes(fieldValue)
                ? prev.filter(f => f !== fieldValue)
                : [...prev, fieldValue]
        );
    };

    const handleGerarRelatorio = () => {
        if (!relatorioTodosContratos && !selectedContratoId) {
            showToast("error", "Selecione um contrato antes de gerar o relatório (ou marque \"Todos os contratos\").");
            return;
        }
        if (selectedFields.length === 0) {
            showToast("error", "Selecione ao menos um campo para o relatório.");
            return;
        }

        const { dataInicio, dataFim } = calcularPeriodoRelatorio(relatorioPeriodo, relatorioDataReferencia);

        const request: AlunoRelatorioRequest = {
            filters: {
                pageNumber: 1,
                pageSize: 999999,
                contratoId: relatorioTodosContratos ? undefined : selectedContratoId,
                empresaId: objUserTk.EmpresaId,
                cursoId: relatorioTodosContratos ? undefined : selectedCursoFiltroAlunos?.value,
                name: relatorioNomeFormando || undefined,
                dataInicio,
                dataFim,
            },
            camposSelecionados: selectedFields,
        };

        gerarRelatorioAlunos(request);
    };

    //--------------------------------------------

    function getStatusLabel(step: number) {
        switch (step) {
            case 1:
                return "Aberto";
            case 2:
                return "Em preparação";
            case 3:
                return "Finalizado";
            case 4:
                return "Expedição";
            case 5:
                return "Venda";
            case 6:
                return "Cancelado";
            default:
                return "Indefinido";
        }
    }

    function getPreparacaoStatusLabel(status: number) {
        switch (status) {
            case 1:
                return "Aberto";
            case 2:
                return "Em andamento";
            case 3:
                return "Em edição";
            case 4:
                return "Em laboratório";
            case 5:
                return "Aguardando venda";
            case 6:
                return "Finalizado";
            default:
                return "Desconhecido";
        }
    };

    const selectedContract = listContrato.find(contrato => contrato.id === selectedContratoId);

    //--------------------------------------------

    const [profileImageBase64, setProfileImageBase64] = useState<string | null>(null);

    const handleProfileImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setProfileImageBase64(reader.result as string);
        };
        reader.readAsDataURL(file);
    };


    const imageInputRef = useRef<HTMLInputElement>(null);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setEditingAluno(prev => ({
                ...prev!,
                base64Image: reader.result as string,
            }));
        };
        reader.readAsDataURL(file);
    };

    // Memoiza as transformações de listas para evitar recálculos desnecessários
    const listInstituicaoOptions = useMemo(() => 
        listInstituicao.map(instituicao => ({
            value: instituicao.id,
            label: instituicao.name,
        })), 
        [listInstituicao]
    );

    const getInstituicaoCity = (instituicaoId?: number | null) =>
        listInstituicao.find(instituicao => Number(instituicao.id) === Number(instituicaoId))?.city || "";

    const newContratoInstituicaoCity = getInstituicaoCity(newContrato.instituicaoId);
    const editingContratoInstituicaoCity = getInstituicaoCity(editingContrato?.instituicaoId);

    const listCursoOptions = useMemo(() => 
        listCurso.map(curso => ({
            value: curso.id,
            label: curso.name,
        })), 
        [listCurso]
    );

    const listResponsavelOptions = useMemo(() => 
        listResponsavel.map(responsavel => ({
            value: responsavel.id,
            label: responsavel.name,
        })), 
        [listResponsavel]
    );

    const tipoCustoOptions = useMemo(() => 
        listTipoCusto.map(tipoCusto => ({
            value: tipoCusto.id,
            label: tipoCusto.description
        })), 
        [listTipoCusto]
    );

    const options = useMemo(() => 
        events.map(ev => ({
            value: ev.id,
            label: `${ev.id} - ${ev.title}`,
        })), 
        [events]
    );

    const listCursoOptionsToAdd = useMemo(() => 
        listCurso
            .filter(c => !listCursoByContrato.some(vinc => vinc.id === c.id))
            .map(c => ({ value: c.id, label: c.name })), 
        [listCurso, listCursoByContrato]
    );

    // const handleSelectCursosToAdd = (selected: any) => {
    //     setSelectedCursosToAdd(selected ? selected.map((o: any) => o.value) : []);
    // };

    const handleSelectCursosToAdd = async (selected: any, actionMeta?: any) => {
        setSelectedCursosToAdd(selected ? selected.map((o: any) => o.value) : []);

        if (!editingContrato) {
            showToast("error", "Contrato não carregado.");
            return;
        }

        if (actionMeta?.action === "select-option" && actionMeta?.option?.value) {
            const cursoId: number = actionMeta.option.value;

            if (listCursoByContrato.some(c => c.id === cursoId)) return;

            setIsSyncingCursos(true);
            try {
                await addCursoAoContrato(editingContrato.id, cursoId);
                showToast("success", "Curso vinculado ao contrato.");

                await handleGetCursoByContratoId(editingContrato.id);

                setSelectedCursosToAdd([]);
            } catch (e) {
                console.error(e);
            } finally {
                setIsSyncingCursos(false);
            }
        }

        // if (actionMeta?.action === "remove-value" && actionMeta?.removedValue?.value) {
        //   const removedId: number = actionMeta.removedValue.value;
        //   await handleRemoverCursoDoContrato(removedId);
        // }
    };

    const handleAddCursosAoContrato = async () => {
        if (!editingContrato) {
            showToast("error", "Contrato não carregado.");
            return;
        }
        if (!selectedCursosToAdd.length) {
            showToast("error", "Selecione ao menos um curso para adicionar.");
            return;
        }

        const toAdd = selectedCursosToAdd.filter(
            id => !listCursoByContrato.some(c => c.id === id)
        );

        if (toAdd.length === 0) {
            showToast("info", "Todos os cursos selecionados já estão vinculados.");
            return;
        }

        setIsSyncingCursos(true);
        try {
            await Promise.all(toAdd.map(id => addCursoAoContrato(editingContrato.id, id)));
            showToast("success", `${toAdd.length} curso(s) vinculado(s) ao contrato.`);

            await handleGetCursoByContratoId(editingContrato.id);

            setSelectedCursosToAdd([]);
        } catch (e) {
            console.error(e);
        } finally {
            setIsSyncingCursos(false);
        }
    };

    const handleRemoverCursoDoContrato = (cursoId: number) => {
        if (!editingContrato) {
            showToast("error", "Contrato não carregado.");
            return;
        }

        setPendingDelete({
            type: "removerCursoDoContrato",
            ids: { cursoId },
            force: false,
            title: "Remover curso do contrato",
            message: "Tem certeza que deseja remover este curso do contrato? Todos os alunos vinculados a este curso, neste contrato, perderão o vínculo.",
        });
    };

    const openCopyTransferModal = async () => {
        if (!selectedContratoId) {
            showToast("error", "Selecione um contrato antes.");
            return;
        }
        if (!selectedAlunosIds.length) {
            showToast("error", "Selecione ao menos 1 aluno.");
            return;
        }
        try {
            const response = await api.get(`/Contrato/getContratoByEmpresaId/${objUserTk.EmpresaId}`);
            setAllContratosForModal(response.data ?? []);
        } catch {
            setAllContratosForModal([]);
        }
        setCopyTransferModalOpen(true);
    };

    const resolveCursoIdFromAluno = (a: any): number => {
        const raw =
            a?.cursoId ??
            a?.CursoId ??
            a?.curso?.id ??
            a?.curso?.Id ??
            a?.Curso?.id ??
            a?.Curso?.Id ??
            0;

        const n = Number(raw);
        if (Number.isFinite(n) && n > 0) return n;
        const nome = String(a?.cursoName ?? a?.CursoName ?? "").trim().toLowerCase();
        if (!nome) return 0;

        const match = listCurso.find(c => String(c?.name ?? "").trim().toLowerCase() === nome);
        return Number(match?.id ?? 0) || 0;
    };

    const handleTargetContratoChange = async (contratoId: number) => {
        setTargetContratoId(contratoId);
        setTargetCursoId(0);
        setTargetCursosList([]);

        if (!contratoId) return;

        if (contratoId === selectedContratoId) {
            setCopyTransferMode("transfer");
            setTargetCursosList(listCursoByContrato);
            return;
        }

        setIsTargetCursosLoading(true);
        try {
            const res = await api.get(`/Curso/getCursosByContratoId?contratoId=${contratoId}`);
            setTargetCursosList(res.data ?? []);
        } catch {
            setTargetCursosList([]);
        } finally {
            setIsTargetCursosLoading(false);
        }
    };

    const handleConfirmCopyTransfer = async () => {
        try {
            if (!selectedAlunosIds.length) {
                showToast("error", "Selecione ao menos 1 aluno.");
                return;
            }

            if (!targetContratoId) {
                showToast("error", "Selecione um contrato destino válido.");
                return;
            }

            if (targetContratoId === selectedContratoId && !targetCursoId) {
                showToast("error", "Para o mesmo contrato, selecione o curso de destino.");
                return;
            }

            const selectedAlunos = listAluno.filter(a => selectedAlunosIds.includes(a.id));
            if (!selectedAlunos.length) {
                showToast("error", "Selecione ao menos 1 aluno.");
                return;
            }

            const alunoCursoItems: AlunoCursoItem[] = selectedAlunos.map(a => ({
                alunoId: a.id,
                cursoId: resolveCursoIdFromAluno(a),
            }));

            const semCurso = alunoCursoItems.filter(x => x.cursoId === 0);
            if (semCurso.length) {
                showToast(
                    "error",
                    `Não foi possível identificar o curso de ${semCurso.length} aluno(s).`
                );
                return;
            }

            setIsCopyTransferLoading(true);

            const payload: CopyTransferAlunosRequest = {
                sourceContratoId: selectedContratoId,
                targetContratoId: targetContratoId,
                alunos: alunoCursoItems,
                targetCursoId: targetCursoId > 0 ? targetCursoId : undefined,
                mode: targetContratoId === selectedContratoId ? "transfer" : copyTransferMode,
            };

            const res = await copyTransferAlunos(payload);

            if (!res) {
                return;
            }

            if (res.missingCursos?.length) {
                return;
            }

            setCopyTransferModalOpen(false);
            resetCopyTransferModal();

            const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
            await getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
        } catch (e) {
            console.error(e);
            showToast("error", "Erro ao processar a ação.");
        } finally {
            setIsCopyTransferLoading(false);
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar Contratos"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                {/* <Row className="align-items-center mb-4"> */}
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="2" lg="2" className="mb-2">
                        <Label className="form-control-label" for="idContrato">Contrato</Label>
                        <Input
                            className="form-control-alternative"
                            type="number"
                            name="idContrato"
                            id="idContrato"
                            placeholder="Buscar pela sequência"
                            value={dataSearch.idContrato}
                            onChange={(e) => setDataSearch({ ...dataSearch, idContrato: Number(e.target.value) })}
                        />
                    </Col>
                    {/* <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" for="description">Descrição</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="description"
                            id="description"
                            placeholder="Buscar por descrição"
                            value={dataSearch.description}
                            onChange={(e) => setDataSearch({ ...dataSearch, description: e.target.value })}
                        />
                    </Col> */}
                    <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" htmlFor="description">Descrição</Label>

                        <AsyncSelect
                            inputId="description"
                            className="form-control-alternative"
                            classNamePrefix="react-select"
                            placeholder="Selecione ou digite uma descrição..."
                            isClearable
                            cacheOptions
                            defaultOptions={[]}
                            loadOptions={async (inputValue) => {
                                const q = (inputValue || "").trim();
                                if (!q) return [];
                                const items = await suggestContratoDescriptions(q, 10);
                                return items.map(s => ({ value: s, label: s }));
                            }}
                            value={
                                dataSearch.description
                                    ? { value: dataSearch.description, label: dataSearch.description }
                                    : null
                            }
                            onChange={(opt) => {
                                const val = (opt as { value: string } | null)?.value ?? "";
                                setDataSearch({ ...dataSearch, description: val });
                            }}
                            onInputChange={(val, meta) => {
                                if (meta.action === "input-change") return val;
                                return val;
                            }}
                            noOptionsMessage={() => "Nenhuma descrição encontrada"}
                            loadingMessage={() => "Carregando..."}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                        />
                    </Col>

                    <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" for="city">Cidade</Label>
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="city"
                            id="city"
                            placeholder="Buscar por cidade"
                            value={dataSearch.city}
                            onChange={(e) => setDataSearch({ ...dataSearch, city: e.target.value })}
                        />
                    </Col>
                    <Col xs="12" md="2" lg="2" className="mb-2">
                        <Label className="form-control-label" for="status">Status</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="status"
                            id="status"
                            value={dataSearch.status}
                            onChange={(e) =>
                                setDataSearch({ ...dataSearch, status: Number(e.target.value) })
                            }
                        >
                            <option value={0}>Todos</option>
                            <option value={1}>Aberto</option>
                            <option value={2}>Em andamento</option>
                            <option value={3}>Finalizado</option>
                            <option value={4}>Expedição</option>
                            <option value={5}>Venda</option>
                            <option value={6}>Cancelado</option>
                        </Input>
                    </Col>
                </Row>
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="2" lg="2" className="mb-2">
                        <Label className="form-control-label" for="state">Estado</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="state"
                            id="state"
                            value={dataSearch.state}
                            onChange={(e) => setDataSearch({ ...dataSearch, state: e.target.value })}
                        >
                            <option value="">Todos</option>
                            {["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"].map((uf) => (
                                <option key={uf} value={uf}>{uf}</option>
                            ))}
                        </Input>
                    </Col>
                    <Col xs="12" md="2" lg="2" className="mb-2">
                        <Label className="form-control-label" for="region">Região</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="region"
                            id="region"
                            value={dataSearch.region}
                            onChange={(e) => setDataSearch({ ...dataSearch, region: e.target.value })}
                        >
                            <option value="">Todas</option>
                            <option value="Norte">Norte</option>
                            <option value="Nordeste">Nordeste</option>
                            <option value="Centro-Oeste">Centro-Oeste</option>
                            <option value="Sudeste">Sudeste</option>
                            <option value="Sul">Sul</option>
                        </Input>
                    </Col>
                    <Col xs="12" md="2" lg="2" className="mb-2">
                        <Label className="form-control-label" for="isPrivate">Rede</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="isPrivate"
                            id="isPrivate"
                            value={dataSearch.isPrivate}
                            onChange={(e) => setDataSearch({ ...dataSearch, isPrivate: e.target.value })}
                        >
                            <option value="">Todas</option>
                            <option value="false">Pública</option>
                            <option value="true">Particular</option>
                        </Input>
                    </Col>
                    <Col xs="12" md="6" lg="6" className="mb-2">
                        <Label className="form-control-label" for="vendedorId">Representante Comercial</Label>
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="vendedorId"
                            id="vendedorId"
                            value={dataSearch.vendedorId}
                            onChange={(e) => setDataSearch({ ...dataSearch, vendedorId: Number(e.target.value) })}
                        >
                            <option value={0}>Todos</option>
                            {listRepresentanteComercial.map((representanteComercial) => (
                                <option key={representanteComercial.id} value={representanteComercial.id}>
                                    {representanteComercial.name}
                                </option>
                            ))}
                        </Input>
                    </Col>
                    <Col xs="12" md="3" lg="3" className="mb-2 d-flex align-items-end">
                        <FormGroup check className="mb-0">
                            <Label check>
                                <Input
                                    type="checkbox"
                                    checked={dataSearch.somenteKit}
                                    onChange={(e) => setDataSearch({ ...dataSearch, somenteKit: e.target.checked })}
                                />
                                Somente Kit
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" for="startDate">Data inicial</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="startDate"
                            id="startDate"
                            placeholder="Data inicial"
                            value={dataSearch.startDate}
                            onChange={(e) =>
                                setDataSearch({ ...dataSearch, startDate: e.target.value })
                            }
                        />
                    </Col>
                    <Col xs="12" md="4" lg="4" className="mb-2">
                        <Label className="form-control-label" for="endDate">Data final</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="endDate"
                            id="endDate"
                            placeholder="Data final"
                            value={dataSearch.endDate}
                            onChange={(e) =>
                                setDataSearch({ ...dataSearch, endDate: e.target.value })
                            }
                        />
                    </Col>
                    <Col xs="12" md="4" lg="4" className="d-flex justify-content-start justify-content-md-end mb--1">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearchButtonClick}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                </Row>
                {hasPermission(PermissionModule.Contratos, 1) && (
                    <Col xs="12" className="text-right mt-3">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            className="btn-filter"
                            onClick={() => {
                                setNewContrato({
                                    description: '',
                                    contractAnnex: '',
                                    class: '',
                                    hiredStudents: 0,
                                    currentStudents: 0,
                                    completionDate: '',
                                    dateOfDischarge: '',
                                    linkSent: false,
                                    freebies: false,
                                    empresaId: objUserTk.EmpresaId,
                                    instituicaoId: 0,
                                    cursoId: [],
                                    vendedorId: 0,
                                    alunoId: [],
                                    status: 0,
                                });
                                setNewCusto({
                                    description: '',
                                    proportionalCurrentStudents: false,
                                    individualValue: 0,
                                    currentBalance: 0,
                                    requestDate: '',
                                    deliveryDate: '',
                                    receiver: '',
                                    observation: '',
                                    isPaid: false,
                                    empresaId: objUserTk.EmpresaId,
                                    contratoId: selectedContratoId,
                                    tipoCustoId: 0,
                                });
                                setCustos([]);
                                setSelectedInstituicaoId(0);
                                setActiveTab("1");
                                setCreateModalOpen(true);
                            }}
                        >
                            Adicionar contrato
                        </Button>
                    </Col>
                )}
                {hasPermission(PermissionModule.Contratos, 1) && (
                    <Col xs="12" className="mt-3">
                        <div className="p-3" style={{ backgroundColor: "#f6f9fc", borderRadius: 6 }}>
                            <Label className="form-control-label d-block mb-2"><strong>Relatório de Contratos</strong></Label>
                            <Row className="align-items-end">
                                <Col xs="6" md="2" className="mb-2">
                                    <Label className="form-control-label">Status</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        value={statusRelatorioContratos}
                                        onChange={(e) => setStatusRelatorioContratos(e.target.value)}
                                    >
                                        <option value="">Todos</option>
                                        <option value="1">Ativo</option>
                                        <option value="2">Em preparação</option>
                                        <option value="3">Em edição</option>
                                        <option value="4">Em laboratório</option>
                                        <option value="5">Aguardando venda</option>
                                        <option value="6">Concluído</option>
                                        <option value="7">Vendido</option>
                                        <option value="8">Baixado</option>
                                        <option value="9">Expedição</option>
                                        <option value="10">Venda</option>
                                        <option value="11">Cancelado</option>
                                    </Input>
                                </Col>
                                <Col xs="6" md="2" className="mb-2">
                                    <Label className="form-control-label">Editor</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        value={editorRelatorioContratos}
                                        onChange={(e) => setEditorRelatorioContratos(e.target.value)}
                                    >
                                        <option value="">Todos</option>
                                        {listEditor.map((editor: any) => (
                                            <option key={editor.id} value={editor.id}>{editor.name}</option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col xs="6" md="2" className="mb-2">
                                    <Label className="form-control-label">Laboratório</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        value={laboratorioRelatorioContratos}
                                        onChange={(e) => setLaboratorioRelatorioContratos(e.target.value)}
                                    >
                                        <option value="">Todos</option>
                                        {listLaboratory.map((lab: any) => (
                                            <option key={lab.id} value={lab.id}>{lab.name}</option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col xs="6" md="2" className="mb-2">
                                    <Label className="form-control-label">Data inicial</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        value={dataInicialRelatorioContratos}
                                        onChange={(e) => setDataInicialRelatorioContratos(e.target.value)}
                                    />
                                </Col>
                                <Col xs="6" md="2" className="mb-2">
                                    <Label className="form-control-label">Data final</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        value={dataFinalRelatorioContratos}
                                        onChange={(e) => setDataFinalRelatorioContratos(e.target.value)}
                                    />
                                </Col>
                                <Col xs="12" md="2" className="mb-2">
                                    <Button
                                        style={{ color: "#FFF", backgroundColor: "#2dce89" }}
                                        type="button"
                                        block
                                        onClick={() => setIsExportRelatorioModalOpen(true)}
                                    >
                                        <i className="fa-solid fa-file-export mr-2"></i>
                                        Exportar
                                    </Button>
                                </Col>
                            </Row>
                            <small className="text-muted d-block">
                                Dica: para ver contratos que vão finalizar este mês, use Data inicial = primeiro dia do mês e Data final = último dia do mês.
                            </small>
                            <small className="text-muted d-block">
                                A exportação também usa os filtros de Cidade, Estado e Descrição da busca no topo da tela.
                            </small>
                        </div>
                    </Col>
                )}
                {/* </Row> */}

                {hasPermission(PermissionModule.Contratos, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Nº Contrato</th>
                                        <th>Descrição</th>
                                        <th>Classe</th>
                                        <th>Status</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listContrato.map((contrato: ContratoType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{contrato.id}</td>
                                                <td>{contrato.description}</td>
                                                <td>{contrato.class}</td>
                                                <td>{getStatusLabel(Number(contrato.status))}</td>
                                                <td>
                                                    {Number(contrato.status) >= 3 ? (
                                                        <Button
                                                            color="success"
                                                            title="Adicionar Preparação de Álbum"
                                                            className="ml-1"
                                                            onClick={() => {
                                                                setNewPreparacaoAlbum({
                                                                    description: "",
                                                                    numberOfPhotos: 0,
                                                                    numberOfAlbums: 0,
                                                                    editorDeliveryDate: "",
                                                                    editorReturnDate: "",
                                                                    laboratoryDeliveryDate: "",
                                                                    laboratoryReturnDate: "",
                                                                    empresaId: Number(objUserTk.EmpresaId),
                                                                    contratoId: contrato.id,
                                                                    editorId: 0,
                                                                    laboratorioId: 0,
                                                                });
                                                                handleGetCursoByContratoId(contrato.id);
                                                                setSelectedContratoId(contrato.id);
                                                                getPreparacaoAlbumPaged(1, Number(objUserTk.EmpresaId), contrato.id, 9);
                                                                setCreatePreparacaoAlbumModalOpen(true);
                                                            }}
                                                        >
                                                            <i className="fa-solid fa-book"></i>
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            className="ml-1"
                                                            style={{ visibility: 'hidden' }}
                                                        >
                                                            <i className="fa-solid fa-book"></i>
                                                        </Button>
                                                    )}
                                                    <Button onClick={() => downloadContratoPdf(contrato.id)} color="primary" title="Baixar PDF"><i className="fa-solid fa-download"></i></Button>
                                                    <Button
                                                        onClick={() => abrirStatusAssinatura(contrato.id)}
                                                        color="secondary"
                                                        title="Ver status da assinatura"
                                                    >
                                                        <i className="fa-solid fa-clipboard-check"></i>
                                                    </Button>
                                                    {hasPermission(PermissionModule.Contratos, 3) && (
                                                        <Button onClick={() => { handleEditContrato(contrato); setActiveTab("1"); }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {hasPermission(PermissionModule.Contratos, 4) && (
                                                        <Button onClick={() => handleDeleteContrato(contrato.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {pageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={pageCount}
                                        />
                                    </div>
                                )}
                                {listContrato.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os contratos.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => {
                setCreateModalOpen(!createModalOpen);
                setNewContrato({ description: '', contractAnnex: '', class: '', hiredStudents: 0, currentStudents: 0, completionDate: '', dateOfDischarge: '', linkSent: false, freebies: false, empresaId: objUserTk.EmpresaId, instituicaoId: 0, cursoId: [], vendedorId: 0, alunoId: [], status: 0 });
            }} backdrop="static" className={classnames("custom-modal-xl", { "contrato-wide-modal": activeTab === "2" || activeTab === "3" })}>
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar novo contrato</ModalHeader>
                <ModalBody>
                    <Nav tabs className="d-flex w-100">
                        {["Dados do contrato", "Alunos", "Brindes/Solicitações", "Eventos previstos"].map((label, index) => (
                            <NavItem key={index} className="flex-fill text-center">
                                <NavLink className={classnames({ active: activeTab === `${index + 1}` })} onClick={() => toggleTab(`${index + 1}`)} style={{ cursor: 'pointer' }}>
                                    {label}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <Form onSubmit={handleCreateContrato} className='mt-3'>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Descrição do contrato
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="textarea"
                                                name="description"
                                                id="description"
                                                value={newContrato.description}
                                                onChange={handleCreateInputChange}
                                                placeholder="Ex: Vendas, Direitos Autorais etc..."
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="contractAnnex">
                                                Anexo do contrato (PDF)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="file"
                                                name="contractAnnex"
                                                id="contractAnnex"
                                                accept="application/pdf"
                                                onChange={handleFileUpload}
                                            />
                                            {newContrato.contractAnnex && (
                                                <p style={{ fontSize: "0.9rem", color: "green" }}>
                                                    Arquivo carregado com sucesso!
                                                </p>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="contrato-dados-row-compact">
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label">Instituição</Label>
                                            <InputGroup>
                                                <div style={{ flex: 1 }}>
                                                    <Select
                                                        className="form-control-alternative"
                                                        options={listInstituicaoOptions}
                                                        value={listInstituicaoOptions.find(opt => opt.value === newContrato.instituicaoId)}
                                                        onChange={(selectedOption) =>
                                                            handleInstituicaoChange({
                                                                target: {
                                                                    name: 'instituicaoId',
                                                                    value: selectedOption?.value?.toString() || '0',
                                                                },
                                                            } as React.ChangeEvent<HTMLInputElement>)
                                                        }
                                                        placeholder="Selecione uma instituição..."
                                                        isClearable
                                                        classNamePrefix="react-select"
                                                    />
                                                </div><Button
                                                        style={{ color: "#FFF", backgroundColor: "#585858" }}
                                                        onClick={() => setCreateInstituicaoModalOpen(true)}
                                                    >
                                                        +
                                                    </Button></InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" style={{ order: 5 }}>
                                        <FormGroup>
                                            <Label className="form-control-label">Responsável</Label>
                                            <Select
                                                className="form-control-alternative"
                                                options={listResponsavelOptions}
                                                value={listResponsavelOptions.find(opt => opt.value === newContrato.responsavelId)}
                                                onChange={(selectedOption) =>
                                                    handleCreateInputChange({
                                                        target: {
                                                            name: 'responsavelId',
                                                            value: selectedOption?.value?.toString() || '0',
                                                        },
                                                    } as React.ChangeEvent<HTMLInputElement>)
                                                }
                                                placeholder={
                                                    listResponsavel.length === 0
                                                        ? 'Nenhum responsável atribuído pela instituição'
                                                        : 'Selecione um responsável...'
                                                }
                                                isDisabled={listResponsavel.length === 0 || newContrato.instituicaoId === 0}
                                                isClearable
                                                classNamePrefix="react-select"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label">Cidade da instituição</Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                value={newContratoInstituicaoCity}
                                                placeholder="Cidade da instituição"
                                                disabled
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label">Curso</Label>
                                            <InputGroup>
                                                <div style={{ flex: 1 }}>
                                                    <Select
                                                        options={listCursoOptions}
                                                        value={selectedCursos.map(curso => ({
                                                            value: curso.id,
                                                            label: curso.name
                                                        }))}
                                                        onChange={(selectedOptions) => {
                                                            const cursos = selectedOptions ? selectedOptions.map(opt => ({
                                                                id: opt.value,
                                                                name: opt.label
                                                            })) : [];
                                                            setSelectedCursos(cursos);
                                                        }}
                                                        isMulti
                                                        placeholder="Selecione os cursos..."
                                                        classNamePrefix="react-select"
                                                    />
                                                </div><Button
                                                        style={{ background: '#585858', color: '#fff' }}
                                                        onClick={() => setCreateCursoModalOpen(true)}
                                                    >
                                                        +
                                                    </Button></InputGroup>

                                            <div className="mt-2">
                                                {selectedCursos.map((curso) => (
                                                    <span key={curso.id} className="badge badge-primary mr-2">
                                                        {curso.name}
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger ml-1"
                                                            onClick={() => setSelectedCursos(selectedCursos.filter(c => c.id !== curso.id))}
                                                        >
                                                            x
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Classe
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="class"
                                                id="class"
                                                value={newContrato.class}
                                                onChange={handleCreateInputChange}
                                                placeholder="Descrição e/ou nome da classe"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Alunos contratados
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="hiredStudents"
                                                id="hiredStudents"
                                                value={newContrato.hiredStudents}
                                                onChange={handleCreateInputChange}
                                                required
                                                placeholder="Quantidade de alunos que foram contratados"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Alunos atuais
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="currentStudents"
                                                id="currentStudents"
                                                value={newContrato.currentStudents}
                                                onChange={handleCreateInputChange}
                                                placeholder="Quantidade de alunos restantes"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Data de conclusão
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="date"
                                                name="completionDate"
                                                id="completionDate"
                                                value={newContrato.completionDate?.toString()}
                                                onChange={handleCreateInputChange}
                                                placeholder="Data de conclusão do contrato"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Data da baixa
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="date"
                                                name="dateOfDischarge"
                                                id="dateOfDischarge"
                                                value={newContrato.dateOfDischarge?.toString()}
                                                onChange={handleCreateInputChange}
                                                placeholder="Data da baixa"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label">Representante Comercial</Label>
                                            <InputGroup>
                                                <Input
                                                    className="form-control-alternative"
                                                    type="select"
                                                    name="vendedorId"
                                                    value={newContrato.vendedorId}
                                                    onChange={handleCreateInputChange}
                                                >
                                                    <option value="">Selecione um representante comercial</option>
                                                    {listRepresentanteComercial.map((representanteComercial) => (
                                                        <option key={representanteComercial.id} value={representanteComercial.id}>
                                                            {representanteComercial.name}
                                                        </option>
                                                    ))}
                                                </Input><Button
                                                        style={{ background: '#585858', color: '#fff' }}
                                                        onClick={() => setCreateVendedorModalOpen(true)}
                                                    >
                                                        +
                                                    </Button></InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Input
                                                className="form-control-alternative ml-1"
                                                type="checkbox"
                                                name="linkSent"
                                                id="linkSent"
                                                value={newContrato.linkSent == true ? "true" : "false"}
                                                onChange={handleCreateInputChange}
                                            />
                                            <Label className="form-control-label ml-4" htmlFor="input-description">
                                                Link enviado
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Input
                                                className="form-control-alternative"
                                                type="checkbox"
                                                name="freebies"
                                                id="freebies"
                                                value={newContrato.freebies == true ? "true" : "false"}
                                                onChange={handleCreateInputChange}
                                            />
                                            <Label className="form-control-label ml-1" htmlFor="input-description">
                                                Brindes OK
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="status">
                                                Status
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="select"
                                                name="status"
                                                id="status"
                                                value={newContrato.status}
                                                onChange={handleCreateInputChange}
                                            >
                                                <option value={0}>Selecione...</option>
                                                <option value={1}>Aberto</option>
                                                <option value={2}>Em andamento</option>
                                                <option value={3}>Finalizado</option>
                                                <option value={4}>Expedição</option>
                                                <option value={5}>Venda</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {/* Campos de compra e venda ocultos temporariamente (aguardando retorno da Endoc sobre assinatura fixa). O backend continua aceitando estes campos; para reativar, remova este bloco de comentario e o fechamento correspondente abaixo.
                                <hr />
                                <h5 className="mb-3">Dados do contrato de assinatura (compra e venda)</h5>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="productDescription">
                                                Descrição do álbum / composição do produto
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="textarea"
                                                name="productDescription"
                                                id="productDescription"
                                                value={newContrato.productDescription ?? ''}
                                                onChange={handleCreateInputChange as any}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="buyerAddress">
                                                Endereço do comprador
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="buyerAddress"
                                                id="buyerAddress"
                                                value={newContrato.buyerAddress ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="sellerAddress">
                                                Endereço da vendedora (opcional)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="sellerAddress"
                                                id="sellerAddress"
                                                value={newContrato.sellerAddress ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="buyerNationality">
                                                Nacionalidade (opcional)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="buyerNationality"
                                                id="buyerNationality"
                                                value={newContrato.buyerNationality ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="buyerMaritalStatus">
                                                Estado civil (opcional)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="buyerMaritalStatus"
                                                id="buyerMaritalStatus"
                                                value={newContrato.buyerMaritalStatus ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="buyerProfession">
                                                Profissão (opcional)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="buyerProfession"
                                                id="buyerProfession"
                                                value={newContrato.buyerProfession ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="totalValue">
                                                Valor total (R$)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                step="0.01"
                                                name="totalValue"
                                                id="totalValue"
                                                value={newContrato.totalValue ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="8">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="totalValueText">
                                                Valor total por extenso
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="totalValueText"
                                                id="totalValueText"
                                                value={newContrato.totalValueText ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="downPaymentValue">
                                                Entrada (R$)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                step="0.01"
                                                name="downPaymentValue"
                                                id="downPaymentValue"
                                                value={newContrato.downPaymentValue ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="installmentsCount">
                                                Nº de parcelas
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="installmentsCount"
                                                id="installmentsCount"
                                                value={newContrato.installmentsCount ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="installmentValue">
                                                Valor da parcela (R$)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                step="0.01"
                                                name="installmentValue"
                                                id="installmentValue"
                                                value={newContrato.installmentValue ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="paymentDueDay">
                                                Dia de vencimento
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="paymentDueDay"
                                                id="paymentDueDay"
                                                value={newContrato.paymentDueDay ?? ''}
                                                onChange={handleCreateInputChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                */}
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="cnpjAssinaturaNovoContrato">
                                                Enviar para assinatura digital (CNPJ da Flash)
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="select"
                                                name="cnpjAssinaturaNovoContrato"
                                                id="cnpjAssinaturaNovoContrato"
                                                value={cnpjAssinaturaNovoContrato}
                                                onChange={(e) => setCnpjAssinaturaNovoContrato(e.target.value)}
                                            >
                                                <option value="">Não enviar agora</option>
                                                {flashCnpjs.map((f) => (
                                                    <option key={f.cnpj} value={f.cnpj}>
                                                        {f.name} — {f.cnpj}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-end mt-3">
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m" disabled={assinaturaLoading}>
                                        {assinaturaLoading ? "Enviando para assinatura..." : "Criar Contrato"}
                                    </Button>
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => { setCreateModalOpen(!createModalOpen); resetFormState(); }} size="m" className="ml-2">Cancelar</Button>
                                </div>
                            </Form>
                        </TabPane>
                        <TabPane tabId="2">
                            {hasPermission(PermissionModule.Contratos, 2) ? (
                                <Row className="mt-4">
                                    <Col>
                                        <Table hover responsive className="table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50px", textAlign: "center" }}>✓</th>
                                                    <th style={{ width: "90px", textAlign: "center" }}>
                                                        <span>Detalhes</span>
                                                        <Button
                                                            size="sm"
                                                            color="link"
                                                            className="p-0 ml-2 aluno-details-toggle"
                                                            title={allVisibleAlunoDetailsExpanded ? "Recolher detalhes de todos" : "Expandir detalhes de todos"}
                                                            onClick={toggleAllVisibleAlunoDetails}
                                                        >
                                                            <i className={`fa-solid ${allVisibleAlunoDetailsExpanded ? "fa-chevron-up" : "fa-chevron-right"}`}></i>
                                                        </Button>
                                                    </th>
                                                    <th>Código ref.</th>
                                                    <th>Nome</th>
                                                    <th>Email</th>
                                                    <th>CPF</th>
                                                    <th>Endereço</th>
                                                    <th>Telefone Fixo</th>
                                                    <th>
                                                        <div className="d-flex align-items-center">
                                                            <span>Telefone 01</span>
                                                            <Button
                                                                size="sm"
                                                                color="link"
                                                                className="p-0 ml-2"
                                                                title={showAllPhoneColumns ? "Recolher telefones" : "Expandir telefones"}
                                                                onClick={() => setShowAllPhoneColumns(prev => !prev)}
                                                            >
                                                                <i className={`fa-solid ${showAllPhoneColumns ? "fa-chevron-left" : "fa-chevron-right"}`}></i>
                                                            </Button>
                                                        </div>
                                                    </th>
                                                    {showAllPhoneColumns && (
                                                        <>
                                                            <th>Telefone 02</th>
                                                            <th>Telefone 03</th>
                                                            <th>Telefone 04</th>
                                                            <th>Telefone 05</th>
                                                            <th>Telefone 06</th>
                                                        </>
                                                    )}
                                                    <th>Manter fotos</th>
                                                    <th>Álbum</th>
                                                    <th>Nº de fotos</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listAluno.map((aluno: AlunoType) => (
                                                    <React.Fragment key={`${aluno.id}-${aluno.cursoId}`}>
                                                    <tr>
                                                        <td style={{ textAlign: "center", width: "50px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                            <Input
                                                                type="checkbox"
                                                                checked={selectedAlunosIds.includes(aluno.id)}
                                                                onChange={() => handleAlunoSelection(aluno.id)}
                                                                style={{ transform: "scale(1.1)", cursor: "pointer", margin: "auto" }}
                                                            />
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>
                                                            <Button
                                                                size="sm"
                                                                color="link"
                                                                className="p-0 aluno-details-toggle"
                                                                title={expandedAlunoPhones.has(aluno.id) ? "Recolher detalhes deste aluno" : "Expandir detalhes deste aluno"}
                                                                onClick={() => toggleAlunoPhones(aluno.id)}
                                                            >
                                                                <i className={`fa-solid ${expandedAlunoPhones.has(aluno.id) ? "fa-chevron-up" : "fa-chevron-right"}`}></i>
                                                            </Button>
                                                        </td>
                                                        <td>{aluno.referenceCode}</td>
                                                        <td>{aluno.name}</td>
                                                        <td>{aluno.email}</td>
                                                        <td>{aluno.cpf}</td>
                                                        <td>{aluno.address}</td>
                                                        <td>{aluno.landline}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <span>{aluno.telephone_01}</span>
                                                            </div>
                                                        </td>
                                                        {showAllPhoneColumns && (
                                                            <>
                                                                <td>{aluno.telephone_02}</td>
                                                                <td>{aluno.telephone_03}</td>
                                                                <td>{aluno.telephone_04}</td>
                                                                <td>{aluno.telephone_05}</td>
                                                                <td>{aluno.telephone_06}</td>
                                                            </>
                                                        )}
                                                        <td>{aluno.keepThePhotos ? "Sim" : "Não"}</td>
                                                        <td>{aluno.hasAlbum ? "Sim" : "Não"}</td>
                                                        <td>{aluno.numberOfPhotos}</td>
                                                    </tr>
                                                    {expandedAlunoPhones.has(aluno.id) && (
                                                        <tr>
                                                            <td colSpan={99}>
                                                                {allVisibleAlunoDetailsExpanded ? (
                                                                    <div className="aluno-details-compact">
                                                                        <span>
                                                                            <strong>Foto:</strong>
                                                                            {aluno.base64Image ? (
                                                                                <img src={aluno.base64Image} alt={`Foto de ${aluno.name}`} className="aluno-detail-photo-compact" />
                                                                            ) : (
                                                                                <span className="aluno-detail-photo-compact aluno-detail-photo-placeholder" />
                                                                            )}
                                                                        </span>
                                                                        <span><strong>Nº:</strong> {aluno.addressNumber || "-"}</span>
                                                                        <span><strong>Bairro:</strong> {aluno.neighborhood || "-"}</span>
                                                                        <span><strong>Cidade:</strong> {aluno.city || "-"}</span>
                                                                        <span><strong>Estado:</strong> {aluno.state || "-"}</span>
                                                                        <span><strong>CEP:</strong> {aluno.zipCode || "-"}</span>
                                                                        <span><strong>Tel 02:</strong> {aluno.telephone_02 || "-"}</span>
                                                                        <span><strong>Tel 03:</strong> {aluno.telephone_03 || "-"}</span>
                                                                        <span><strong>Tel 04:</strong> {aluno.telephone_04 || "-"}</span>
                                                                        <span><strong>Tel 05:</strong> {aluno.telephone_05 || "-"}</span>
                                                                        <span><strong>Tel 06:</strong> {aluno.telephone_06 || "-"}</span>
                                                                        <span><strong>Facebook:</strong> {aluno.facebook || "-"}</span>
                                                                        <span><strong>Instagram:</strong> {aluno.instagram || "-"}</span>
                                                                    </div>
                                                                ) : (
                                                                <div className="aluno-details-grid">
                                                                    <div>
                                                                        <strong>Foto</strong>
                                                                        <div className="mt-2">
                                                                            {aluno.base64Image ? (
                                                                                <img src={aluno.base64Image} alt={`Foto de ${aluno.name}`} className="aluno-detail-photo" />
                                                                            ) : (
                                                                                <div className="aluno-detail-photo aluno-detail-photo-placeholder" />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <strong>Endereço</strong>
                                                                        <div>Nº: {aluno.addressNumber || "-"}</div>
                                                                        <div>Bairro: {aluno.neighborhood || "-"}</div>
                                                                        <div>Cidade: {aluno.city || "-"}</div>
                                                                        <div>Estado: {aluno.state || "-"}</div>
                                                                        <div>CEP: {aluno.zipCode || "-"}</div>
                                                                    </div>
                                                                    <div>
                                                                        <strong>Telefones extras</strong>
                                                                        <div>Telefone 02: {aluno.telephone_02 || "-"}</div>
                                                                        <div>Telefone 03: {aluno.telephone_03 || "-"}</div>
                                                                        <div>Telefone 04: {aluno.telephone_04 || "-"}</div>
                                                                        <div>Telefone 05: {aluno.telephone_05 || "-"}</div>
                                                                        <div>Telefone 06: {aluno.telephone_06 || "-"}</div>
                                                                    </div>
                                                                    <div>
                                                                        <strong>Redes sociais</strong>
                                                                        <div>Facebook: {aluno.facebook || "-"}</div>
                                                                        <div>Instagram: {aluno.instagram || "-"}</div>
                                                                    </div>
                                                                </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </Table>
                                        <div className="d-flex justify-content-end mt-3">
                                            {alunoPageCount && (
                                                <div className="d-flex justify-content-center mt-4">
                                                    <PaginationMaterial
                                                        onChange={(e: any, value: any) => onChangePaginationAluno(e, value)}
                                                        count={alunoPageCount}
                                                    />
                                                </div>
                                            )}
                                            {listAluno.length === 0 && (
                                                <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            ) : (
                                <Row className="mt-4">
                                    <Col>
                                        <div style={{ color: "red", textAlign: "center" }}>
                                            Você não tem permissão para visualizar os alunos.
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </TabPane>
                        <TabPane tabId="3">
                            <Form className='mt-3'>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Descrição do custo
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="textarea"
                                                name="description"
                                                id="description"
                                                value={newCusto.description}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Ex: Material didático, Aluguel de espaço etc..."
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label">Tipo de custo</Label>
                                            <Select
                                                className="form-control-alternative"
                                                classNamePrefix="react-select"
                                                options={tipoCustoOptions}
                                                placeholder="Selecione ou digite para filtrar…"
                                                isClearable

                                                value={
                                                    tipoCustoOptions.find(opt => opt.value === newCusto.tipoCustoId) || null
                                                }
                                                onChange={selectedOption => {
                                                    const tipo = listTipoCusto.find(tc => tc.id === selectedOption?.value);

                                                    let saldoCalculado = 0;
                                                    if (newContrato.currentStudents && newContrato.currentStudents > 0) {
                                                        saldoCalculado = newContrato.currentStudents;
                                                    } else if (newContrato.hiredStudents && newContrato.hiredStudents > 0) {
                                                        saldoCalculado = newContrato.hiredStudents;
                                                    }

                                                    handleCreateCustoInputChange({
                                                        target: {
                                                            name: "tipoCustoId",
                                                            value: selectedOption ? selectedOption.value : "",
                                                            type: "select-one"
                                                        }
                                                    } as any);

                                                    setNewCusto(prev => ({
                                                        ...prev,
                                                        individualValue: tipo?.value ?? prev.individualValue,
                                                        currentBalance: saldoCalculado
                                                    }));
                                                }}
                                                filterOption={(option, input) =>
                                                    option.label.toLowerCase().includes(input.toLowerCase())
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="2">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Valor individual
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="individualValue"
                                                id="individualValue"
                                                value={newCusto.individualValue}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Valor individual do custo"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="1">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Saldo
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="currentBalance"
                                                id="currentBalance"
                                                value={newCusto.currentBalance}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Saldo"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Data de solicitação
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="date"
                                                name="requestDate"
                                                id="requestDate"
                                                value={newCusto.requestDate?.toString()}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Data de solicitação"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Data de entrega
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="date"
                                                name="deliveryDate"
                                                id="deliveryDate"
                                                value={newCusto.deliveryDate?.toString()}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Data de entrega"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Data de pagamento
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="date"
                                                name="paymentDate"
                                                id="paymentDate"
                                                value={newCusto.paymentDate?.toString()}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Data de pagamento"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Recebedor
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="receiver"
                                                id="receiver"
                                                value={newCusto.receiver}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Recebedor"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">
                                                Observação
                                            </Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="textarea"
                                                name="observation"
                                                id="observation"
                                                value={newCusto.observation}
                                                onChange={handleCreateCustoInputChange}
                                                placeholder="Observação"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-end mt-3">
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={handleAddCusto} size="m">Adicionar Custo</Button>
                                </div>
                            </Form>
                            <Row className="mt-3">
                                <Col>
                                    <Nav tabs className="mb-3">
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeCustoTab === 'custo' })}
                                                onClick={() => setActiveCustoTab('custo')}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                Custo
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeCustoTab === 'financeiro' })}
                                                onClick={() => setActiveCustoTab('financeiro')}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                Itens do Financeiro
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <TabContent activeTab={activeCustoTab}>
                                        <TabPane tabId="custo">
                                    <div style={{ overflowX: "auto" }}>

                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Sequência</th>
                                                    <th>Descrição</th>
                                                    <th>Tipo do custo</th>
                                                    <th>Valor</th>
                                                    <th>Saldo</th>
                                                    <th>Valor total</th>
                                                    <th>Data de solicitação</th>
                                                    <th>Data de entrega</th>
                                                    <th>Data de pagamento</th>
                                                    <th>Recebedor</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {custos
                                                    .filter(custo => {
                                                        const tipo = listTipoCusto.find(tipo => Number(tipo.id) === Number(custo.tipoCustoId));
                                                        return tipo?.isFinancial === false;
                                                    })
                                                    .map((custo, index) => (
                                                        <tr key={index}>
                                                            <td>{custo.id}</td>
                                                            <td>{custo.description}</td>
                                                            <td>
                                                                {listTipoCusto.find(tipoCusto => Number(tipoCusto.id) === Number(custo.tipoCustoId))?.description || 'Tipo não encontrado'}
                                                            </td>
                                                            <td>{custo.individualValue}</td>
                                                            <td>{custo.currentBalance}</td>
                                                            <td>{formatCurrency(getCustoTotalValue(custo.individualValue, custo.currentBalance, isTipoCustoFixo(custo.tipoCustoId)))}</td>
                                                            <td>{custo.requestDate?.toString() || 'Não definido'}</td>
                                                            <td>{custo.deliveryDate?.toString() || 'Não definido'}</td>
                                                            <td>{custo.paymentDate?.toString() || 'Não definido'}</td>
                                                            <td>{custo.receiver || 'Não definido'}</td>
                                                            <td>
                                                                <Button onClick={() => handleRemoveCusto(index)} color="danger">x</Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                        </TabPane>
                                        <TabPane tabId="financeiro">
                                    <div style={{ overflowX: "auto" }}>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Sequência</th>
                                                    <th>Descrição</th>
                                                    <th>Tipo do custo</th>
                                                    <th>Valor</th>
                                                    <th>Saldo</th>
                                                    <th>Valor total</th>
                                                    <th>Data de solicitação</th>
                                                    <th>Data de entrega</th>
                                                    <th>Data de pagamento</th>
                                                    <th>Recebedor</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {custos
                                                    .filter(custo => {
                                                        const tipo = listTipoCusto.find(tipo => Number(tipo.id) === Number(custo.tipoCustoId));
                                                        return tipo?.isFinancial === true;
                                                    })
                                                    .map((custo, index) => (
                                                        <tr key={index}>
                                                            <td>{custo.id}</td>
                                                            <td>{custo.description}</td>
                                                            <td>
                                                                {listTipoCusto.find(tipoCusto => Number(tipoCusto.id) === Number(custo.tipoCustoId))?.description || 'Tipo não encontrado'}
                                                            </td>
                                                            <td>{custo.individualValue}</td>
                                                            <td>{custo.currentBalance}</td>
                                                            <td>{formatCurrency(getCustoTotalValue(custo.individualValue, custo.currentBalance, isTipoCustoFixo(custo.tipoCustoId)))}</td>
                                                            <td>{custo.requestDate?.toString() || 'Não definido'}</td>
                                                            <td>{custo.deliveryDate?.toString() || 'Não definido'}</td>
                                                            <td>{custo.paymentDate?.toString() || 'Não definido'}</td>
                                                            <td>{custo.receiver || 'Não definido'}</td>
                                                            <td>
                                                                <Button onClick={() => handleRemoveCusto(index)} color="danger">x</Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                        </TabPane>
                                    </TabContent>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="4">
                            <Row className="align-items-center mb-4 mt-4">
                                <Col xs="12" md="2">
                                    <Label className="form-control-label">Data inicial</Label>
                                    <Input
                                        type="date"
                                        value={customStartDate}
                                        onChange={e => setCustomStartDate(e.target.value)}
                                        className="form-control-alternative"
                                    />
                                </Col>

                                <Col xs="12" md="2">
                                    <Label className="form-control-label">Data final</Label>
                                    <Input
                                        type="date"
                                        value={customEndDate}
                                        onChange={e => setCustomEndDate(e.target.value)}
                                        className="form-control-alternative"
                                    />
                                </Col>

                                <Col xs="12" md="4">
                                    <FormGroup>
                                        <Label className="form-control-label">Selecionar eventos específicos</Label>
                                        <Select
                                            isMulti
                                            options={options}
                                            value={options.filter(o => selectedAgendaIds.includes(o.value))}
                                            onChange={handleMultiSelectChange}
                                            placeholder="Digite para buscar eventos..."
                                            className="form-control-alternative"
                                            classNamePrefix="select"
                                            styles={{
                                                menu: base => ({ ...base, zIndex: 9999 }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                            }}
                                            menuPortalTarget={document.body}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col xs="12" md="4" className="d-flex justify-content-md-end">
                                    <Button
                                        style={{ background: "#585858", color: "#FFF" }}
                                        onClick={handlePrintPdf}
                                    >
                                        Imprimir PDF por Período/Eventos
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        style={{ background: "#585858", color: "#FFF" }}
                                        onClick={handleDownloadPdf}
                                    >
                                        Baixar PDF por Período/Eventos
                                    </Button>
                                </Col>
                            </Row>

                            <Row className="mt-5">
                                <Col>
                                    <DnDCalendar
                                        localizer={localizer}
                                        events={events}
                                        startAccessor={(event: any) => new Date(event.start)}
                                        endAccessor={(event: any) => new Date(event.end)}
                                        selectable
                                        onSelectSlot={handleSelectSlot}
                                        onSelectEvent={handleSelectEvent}
                                        onEventDrop={handleEventDrop}
                                        resizable
                                        messages={messages}
                                        view={currentView}
                                        onView={(view) => setCurrentView(view)}
                                        views={{ month: true, week: true, day: true, agenda: true }}
                                        date={currentView === 'agenda' ? agendaBaseDate : undefined}
                                        length={730}
                                        formats={{
                                            agendaDateFormat: (date, culture, localizer) =>
                                                moment(date).format('dddd, DD [de] MMMM [de] YYYY'),
                                            agendaTimeFormat: 'HH:mm',
                                            timeGutterFormat: 'HH:mm',
                                        }}
                                        style={{ height: 500 }}
                                        components={{
                                            agenda: {
                                                event: CustomAgendaEvent
                                            }
                                        }}
                                    />
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="5">
                            <p>Observações</p>
                        </TabPane>
                    </TabContent>
                </ModalBody >
            </Modal >

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" className={classnames("custom-modal-xl", { "contrato-wide-modal": activeTab === "2" || activeTab === "3" })}>
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar informações do contrato</ModalHeader>
                <ModalBody>
                    {editingContrato && (
                        <>
                            <Nav tabs className="d-flex w-100">
                                {["Dados do contrato", "Alunos", "Brindes/Solicitações", "Eventos previstos", "Observações"].map((label, index) => (
                                    <NavItem key={index} className="flex-fill text-center">
                                        <NavLink className={classnames({ active: activeTab === `${index + 1}` })} onClick={() => toggleTab(`${index + 1}`)} style={{ cursor: 'pointer' }}>
                                            {label}
                                        </NavLink>
                                    </NavItem>
                                ))}
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    {loadingTab1 ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Carregando...</span>
                                            </div>
                                        </div>
                                    ) : (
                                    <>
                                    <Form onSubmit={handleEditSubmit} className='mt-3'>
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="input-description">
                                                        Descrição do contrato
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="textarea"
                                                        name="description"
                                                        id="description"
                                                        value={editingContrato.description}
                                                        onChange={e => setEditingContrato({ ...editingContrato, description: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="contractAnnex">
                                                        Anexo do contrato (PDF)
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="file"
                                                        name="contractAnnex"
                                                        id="contractAnnex"
                                                        accept="application/pdf"
                                                        onChange={handleEditFileUpload}
                                                    />
                                                    {editingContrato.contractAnnex && (
                                                        <Alert color="success" className="d-flex align-items-center mt-2">
                                                            <i className="fa-solid fa-file-pdf fa-lg mr-2"></i>
                                                            <div className="d-flex justify-content-between w-100 align-items-center">
                                                                <span className="font-weight-bold">
                                                                    Um contrato em PDF está anexado a este registro.
                                                                </span>
                                                                <Button
                                                                    color="primary"
                                                                    size="sm"
                                                                    onClick={() => downloadContratoPdf(editingContrato.id)}
                                                                    className="ml-3"
                                                                >
                                                                    <i className="fa-solid fa-eye mr-1"></i> Visualizar Anexo
                                                                </Button>
                                                            </div>
                                                        </Alert>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="contrato-dados-row-compact">
                                            <Col md="3">
                                                <FormGroup>
                                                    <Label className="form-control-label">Instituição</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="select"
                                                        name="instituicaoId"
                                                        value={editingContrato.instituicaoId}
                                                        onChange={handleInstituicaoChange}
                                                        disabled
                                                    >
                                                        <option value="0">Selecione uma instituição</option>
                                                        {listInstituicao.map((instituicao) => (
                                                            <option key={instituicao.id} value={instituicao.id}>
                                                                {instituicao.name}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md="6" style={{ order: 5 }}>
                                                <FormGroup>
                                                    <Label className="form-control-label">Responsável</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="select"
                                                        name="responsavelId"
                                                        value={editingContrato.responsavelId}
                                                        onChange={handleInstituicaoChange}
                                                        disabled
                                                    >
                                                        {editingContrato.responsavelId === 0 || editingContrato.responsavelId === null ? (
                                                            <option value="0">Nenhum responsável atribuído pela instituição</option>
                                                        ) : (
                                                            <>
                                                                <option value="0">Selecione um responsável</option>
                                                                {listResponsavel.map((responsavel) => (
                                                                    <option key={responsavel.id} value={responsavel.id}>
                                                                        {responsavel.name}
                                                                    </option>
                                                                ))}
                                                            </>
                                                        )}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Label className="form-control-label">Cidade da instituição</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="text"
                                                        value={editingContratoInstituicaoCity}
                                                        placeholder="Cidade da instituição"
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                {/* <FormGroup>
                                                    <Label className="form-control-label">Cursos</Label>
                                                    <div>
                                                        {listCursoByContrato.map((curso) => (
                                                            <div key={curso.id?.toString()} className="d-flex align-items-center">
                                                                <span className="badge badge-primary mr-2">{curso.name}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </FormGroup> */}
                                                <FormGroup>
                                                    <Label className="form-control-label">Cursos</Label>

                                                    <InputGroup>
                                                        <div style={{ flex: 1 }}>
                                                            <Select
                                                                options={listCursoOptionsToAdd}
                                                                isMulti
                                                                value={listCursoOptionsToAdd.filter(o => selectedCursosToAdd.includes(o.value))}
                                                                onChange={handleSelectCursosToAdd}
                                                                placeholder="Selecione cursos para adicionar..."
                                                                classNamePrefix="react-select"
                                                                isDisabled={isSyncingCursos || !editingContrato}
                                                            />
                                                        </div><Button
                                                                style={{ background: '#585858', color: '#fff' }}
                                                                onClick={() => setCreateCursoModalOpen(true)}
                                                                disabled={isSyncingCursos}
                                                                title="Cadastrar novo curso"
                                                            >
                                                                +
                                                            </Button></InputGroup>

                                                    <div className="mt-3">
                                                        {listCursoByContrato.map((curso) => (
                                                            <span key={curso.id} className="badge badge-primary mr-2">
                                                                {curso.name}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-danger ml-1"
                                                                    onClick={() => handleRemoverCursoDoContrato(curso.id)}
                                                                    disabled={isSyncingCursos}
                                                                    title="Remover do contrato"
                                                                >
                                                                    x
                                                                </button>
                                                            </span>
                                                        ))}
                                                        {listCursoByContrato.length === 0 && (
                                                            <small className="text-muted d-block mt-2">Nenhum curso vinculado ainda.</small>
                                                        )}
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="input-description">
                                                        Classe
                                                    </Label>
                                                    <FormGroup>
                                                        <Input
                                                            className="form-control-alternative"
                                                            type="text"
                                                            name="class"
                                                            id="input-class"
                                                            value={editingContrato.class}
                                                            onChange={e => setEditingContrato({ ...editingContrato, class: e.target.value })}
                                                        />
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="input-description">
                                                        Alunos contratados
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="number"
                                                        name="hiredStudents"
                                                        id="hiredStudents"
                                                        value={editingContrato.hiredStudents}
                                                        onChange={e => setEditingContrato({ ...editingContrato, hiredStudents: Number(e.target.value) })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="input-description">
                                                        Alunos atuais
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="number"
                                                        name="currentStudents"
                                                        id="currentStudents"
                                                        value={editingContrato.currentStudents}
                                                        onChange={e => setEditingContrato({ ...editingContrato, currentStudents: Number(e.target.value) })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="input-description">
                                                        Data de conclusão
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="date"
                                                        name="completionDate"
                                                        id="completionDate"
                                                        value={editingContrato.completionDate?.toString()}
                                                        onChange={e => setEditingContrato({ ...editingContrato, completionDate: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="input-description">
                                                        Data da baixa
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="date"
                                                        name="dateOfDischarge"
                                                        id="dateOfDischarge"
                                                        value={editingContrato.dateOfDischarge?.toString()}
                                                        onChange={e => setEditingContrato({ ...editingContrato, dateOfDischarge: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <FormGroup>
                                                    <Label className="form-control-label">Representante Comercial</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="select"
                                                        name="vendedorId"
                                                        value={editingContrato.vendedorId}
                                                        onChange={e => setEditingContrato({ ...editingContrato, vendedorId: Number(e.target.value) })}
                                                    >
                                                        <option value="0">Selecione um Representante Comercial</option>
                                                        {listRepresentanteComercial.map((representanteComercial) => (
                                                            <option key={representanteComercial.id} value={representanteComercial.id}>
                                                                {representanteComercial.name}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Input
                                                        className="form-control-alternative ml-1"
                                                        type="checkbox"
                                                        name="linkSent"
                                                        id="linkSent"
                                                        value={editingContrato.linkSent == true ? "true" : "false"}
                                                        onChange={e => setEditingContrato({ ...editingContrato, linkSent: e.target.checked })}
                                                    />
                                                    <Label className="form-control-label ml-4" htmlFor="input-description">
                                                        Link enviado
                                                    </Label>
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="checkbox"
                                                        name="freebies"
                                                        id="freebies"
                                                        value={editingContrato.freebies == true ? "true" : "false"}
                                                        onChange={e => setEditingContrato({ ...editingContrato, freebies: e.target.checked })}
                                                    />
                                                    <Label className="form-control-label ml-1" htmlFor="input-description">
                                                        Brindes OK
                                                    </Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="4">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="status">
                                                        Status
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="select"
                                                        name="status"
                                                        id="status"
                                                        value={editingContrato.status}
                                                        onChange={e => setEditingContrato({ ...editingContrato, status: Number(e.target.value) })}
                                                    >
                                                        <option value={0}>Selecione...</option>
                                                        <option value={1}>Aberto</option>
                                                        <option value={2}>Em andamento</option>
                                                        <option value={3}>Finalizado</option>
                                                        <option value={4}>Expedição</option>
                                                        <option value={5}>Venda</option>
                                                        <option value={6}>Cancelado</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12">
                                                <div className="d-flex justify-content-end">
                                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => handleCopyLink(editingContrato.id)} size="m">Copiar link</Button>
                                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setEditModalOpen(!editModalOpen)} size="m">Cancelar</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                    <Row className="mt-4">
                                        <Col>
                                            <h5>Álbuns vinculados</h5>
                                            <Table hover responsive className="table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Descrição</th>
                                                        <th>Fotos</th>
                                                        <th>Álbuns</th>
                                                        <th>Status</th>
                                                        <th>Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listPreparacaoAlbum.map(item => (
                                                        <tr key={item.id}>
                                                            <td>{item.id}</td>
                                                            <td>{item.description}</td>
                                                            <td>{item.numberOfPhotos}</td>
                                                            <td>{item.numberOfAlbums}</td>
                                                            <td>{getPreparacaoStatusLabel(Number(item.status))}</td>
                                                            <td>
                                                                <Button size="m" onClick={() => handleEditPreparacaoAlbum(item)}>
                                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                                </Button>{' '}
                                                                <Button size="m" color="danger" onClick={() => handleDeletePreparacaoAlbum(item.id)}>
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            <div className="d-flex justify-content-end">
                                                {preparacaoAlbumPageCount && (
                                                    <PaginationMaterial
                                                        onChange={(e, v) => onChangePaginationPreparacaoAlbum(e, v)}
                                                        count={preparacaoAlbumPageCount}
                                                    />
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    </>
                                    )}
                                </TabPane>
                                <TabPane tabId="2">
                                    {loadingTab2 ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Carregando alunos...</span>
                                            </div>
                                        </div>
                                    ) : (
                                    <>
                                    {hasPermission(PermissionModule.Contratos, 2) ? (
                                        <Row className="mt-4">
                                            <Col>
                                                <Row className="mt-2">
                                                    <Col>
                                                        <FormGroup>
                                                            <Label className="form-control-label">Campos do Relatório</Label>
                                                            <div className="d-flex align-items-center">
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    type="select"
                                                                    name="field"
                                                                    onChange={handleFieldSelection}
                                                                    style={{ flex: 1 }}
                                                                >
                                                                    <option value="">Selecione um campo</option>
                                                                    {RELATORIO_FIELDS.map(field => (
                                                                        <option key={field.value} value={field.value}>
                                                                            {field.label}
                                                                        </option>
                                                                    ))}
                                                                </Input>

                                                                <Button
                                                                    color="primary"
                                                                    className="ml-3"
                                                                    onClick={handleGerarRelatorio}
                                                                    disabled={selectedFields.length === 0}
                                                                >
                                                                    <i className="fa-solid fa-file-pdf"></i> Gerar Relatório
                                                                </Button>
                                                                <Button
                                                                    color="warning"
                                                                    className="ml-2"
                                                                    onClick={openCopyTransferModal}
                                                                    disabled={!selectedAlunosIds.length}
                                                                >
                                                                    <i className="fa-solid fa-right-left"></i> Copiar/Transferir
                                                                </Button>
                                                                <Button
                                                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                                                    className="btn-filter"
                                                                    onClick={() => setCreateAlunoModalOpen(true)}
                                                                >
                                                                    Adicionar Aluno
                                                                </Button>
                                                                <Button
                                                                    color="danger"
                                                                    className="ml-2"
                                                                    onClick={() => setAlunosSemVinculoModalOpen(true)}
                                                                >
                                                                    <i className="fa-solid fa-link-slash"></i> Alunos sem vínculo
                                                                </Button>
                                                            </div>

                                                            <div className="mt-2">
                                                                {selectedFields.map(value => {
                                                                    const field = RELATORIO_FIELDS.find(f => f.value === value)!;
                                                                    return (
                                                                        <span key={value} className="badge badge-primary mr-2">
                                                                            {field.label}
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-danger ml-1"
                                                                                onClick={() =>
                                                                                    setSelectedFields(prev => prev.filter(f => f !== value))
                                                                                }
                                                                            >
                                                                                x
                                                                            </button>
                                                                        </span>
                                                                    );
                                                                })}
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label className="form-control-label">
                                                                Período de cadastro
                                                            </Label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                type="select"
                                                                value={relatorioPeriodo}
                                                                onChange={(e) => setRelatorioPeriodo(e.target.value as PeriodoRelatorio)}
                                                            >
                                                                <option value="">Todo o período</option>
                                                                <option value="diario">Diário</option>
                                                                <option value="mensal">Mensal</option>
                                                                <option value="trimestral">Trimestral</option>
                                                                <option value="semestral">Semestral</option>
                                                                <option value="anual">Anual</option>
                                                            </Input>
                                                        </FormGroup>
                                                    </Col>
                                                    {relatorioPeriodo && (
                                                        <Col md={3}>
                                                            <FormGroup>
                                                                <Label className="form-control-label">
                                                                    Data de referência do período
                                                                </Label>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    type="date"
                                                                    value={relatorioDataReferencia}
                                                                    onChange={(e) => setRelatorioDataReferencia(e.target.value)}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    )}
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label className="form-control-label">
                                                                Nome do formando
                                                            </Label>
                                                            <Input
                                                                className="form-control-alternative"
                                                                type="text"
                                                                placeholder="Filtrar por nome..."
                                                                value={relatorioNomeFormando}
                                                                onChange={(e) => setRelatorioNomeFormando(e.target.value)}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3} className="d-flex align-items-center">
                                                        <FormGroup check className="mt-4">
                                                            <Label check>
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={relatorioTodosContratos}
                                                                    onChange={(e) => setRelatorioTodosContratos(e.target.checked)}
                                                                />{' '}
                                                                Todos os contratos (consolidado)
                                                            </Label>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-4 mt-3">
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <Label className="form-control-label">
                                                                Filtrar Alunos por Curso
                                                            </Label>
                                                            <Select
                                                                placeholder="Selecione um curso..."
                                                                isClearable
                                                                options={listCursoByContrato.map(c => ({ value: c.id, label: c.name }))}
                                                                value={selectedCursoFiltroAlunos}
                                                                onChange={(opt) => {
                                                                    const curso = opt as { value: number; label: string } | null;
                                                                    setSelectedCursoFiltroAlunos(curso);
                                                                    const parsed = parseInt(referenceCodeFiltroAlunos, 10);
                                                                    const referenceCode = isNaN(parsed) ? undefined : parsed;
                                                                    getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, curso?.value, referenceCode);
                                                                }}
                                                                noOptionsMessage={() => "Nenhum curso encontrado"}
                                                                menuPortalTarget={document.body}
                                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <Label className="form-control-label">
                                                                Filtrar por Código de Referência
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                placeholder="Digite o código..."
                                                                value={referenceCodeFiltroAlunos}
                                                                onChange={(e) => setReferenceCodeFiltroAlunos(e.target.value)}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Table hover responsive className="table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                style={{
                                                                    width: "56px",
                                                                    minWidth: "56px",
                                                                    maxWidth: "56px",
                                                                    textAlign: "center",
                                                                    verticalAlign: "middle",
                                                                    padding: "0.75rem 0.25rem",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        height: "100%",
                                                                    }}
                                                                >
                                                                    <Input
                                                                        type="checkbox"
                                                                        checked={listAluno.length > 0 && selectedAlunosIds.length === listAluno.length}
                                                                        onChange={() => {
                                                                            if (selectedAlunosIds.length === listAluno.length) setSelectedAlunosIds([]);
                                                                            else setSelectedAlunosIds(listAluno.map(a => a.id));
                                                                        }}
                                                                        style={{
                                                                            position: "static",
                                                                            margin: 0,
                                                                            transform: "scale(1.1)",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </th>
                                                            <th style={{ width: "90px", textAlign: "center" }}>
                                                                <span>Detalhes</span>
                                                                <Button
                                                                    size="sm"
                                                                    color="link"
                                                                    className="p-0 ml-2 aluno-details-toggle"
                                                                    title={allVisibleAlunoDetailsExpanded ? "Recolher detalhes de todos" : "Expandir detalhes de todos"}
                                                                    onClick={toggleAllVisibleAlunoDetails}
                                                                >
                                                                    <i className={`fa-solid ${allVisibleAlunoDetailsExpanded ? "fa-chevron-up" : "fa-chevron-right"}`}></i>
                                                                </Button>
                                                            </th>
                                                            <th>Sequência</th>
                                                            <th>Código ref.</th>
                                                            <th>Nome</th>
                                                            <th>Email</th>
                                                            <th>Curso</th>
                                                            <th>CPF</th>
                                                            <th>Endereço</th>
                                                            <th>Telefone Fixo</th>
                                                            <th>
                                                                <div className="d-flex align-items-center">
                                                                    <span>Telefone 01</span>
                                                                    <Button
                                                                        size="sm"
                                                                        color="link"
                                                                        className="p-0 ml-2"
                                                                        title={showAllPhoneColumns ? "Recolher telefones" : "Expandir telefones"}
                                                                        onClick={() => setShowAllPhoneColumns(prev => !prev)}
                                                                    >
                                                                        <i className={`fa-solid ${showAllPhoneColumns ? "fa-chevron-left" : "fa-chevron-right"}`}></i>
                                                                    </Button>
                                                                </div>
                                                            </th>
                                                            {showAllPhoneColumns && (
                                                                <>
                                                                    <th>Telefone 02</th>
                                                                    <th>Telefone 03</th>
                                                                    <th>Telefone 04</th>
                                                                    <th>Telefone 05</th>
                                                                    <th>Telefone 06</th>
                                                                </>
                                                            )}
                                                            <th>Manter fotos</th>
                                                            <th>Álbum</th>
                                                            <th>Nº de fotos</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {listAluno.map((aluno: AlunoType) => (
                                                            <React.Fragment key={`${aluno.id}-${aluno.cursoId}`}>
                                                            <tr>
                                                                <td
                                                                    style={{
                                                                        width: "56px",
                                                                        minWidth: "56px",
                                                                        maxWidth: "56px",
                                                                        textAlign: "center",
                                                                        verticalAlign: "middle",
                                                                        padding: "0.75rem 0.25rem",
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <Input
                                                                            type="checkbox"
                                                                            checked={selectedAlunosIds.includes(aluno.id)}
                                                                            onChange={() => handleAlunoSelection(aluno.id)}
                                                                            style={{
                                                                                position: "static",
                                                                                margin: 0,
                                                                                transform: "scale(1.1)",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    <Button
                                                                        size="sm"
                                                                        color="link"
                                                                        className="p-0 aluno-details-toggle"
                                                                        title={expandedAlunoPhones.has(aluno.id) ? "Recolher detalhes deste aluno" : "Expandir detalhes deste aluno"}
                                                                        onClick={() => toggleAlunoPhones(aluno.id)}
                                                                    >
                                                                        <i className={`fa-solid ${expandedAlunoPhones.has(aluno.id) ? "fa-chevron-up" : "fa-chevron-right"}`}></i>
                                                                    </Button>
                                                                </td>
                                                                <td>{aluno.id}</td>
                                                                <td>{aluno.referenceCode}</td>
                                                                <td>{aluno.name}</td>
                                                                <td>{aluno.email}</td>
                                                                <td>{aluno.cursoName}</td>
                                                                <td>{aluno.cpf}</td>
                                                                <td>{aluno.address}</td>
                                                                <td>{aluno.landline}</td>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <span>{aluno.telephone_01}</span>
                                                                    </div>
                                                                </td>
                                                                {showAllPhoneColumns && (
                                                                    <>
                                                                        <td>{aluno.telephone_02}</td>
                                                                        <td>{aluno.telephone_03}</td>
                                                                        <td>{aluno.telephone_04}</td>
                                                                        <td>{aluno.telephone_05}</td>
                                                                        <td>{aluno.telephone_06}</td>
                                                                    </>
                                                                )}
                                                                <td>{aluno.keepThePhotos ? "Sim" : "Não"}</td>
                                                                <td>{aluno.hasAlbum ? "Sim" : "Não"}</td>
                                                                <td>{aluno.numberOfPhotos}</td>
                                                                <td>
                                                                    {hasPermission(PermissionModule.Contratos, 3) && (
                                                                        <Button onClick={() => handleEditAluno(aluno)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                                    )}
                                                                    {hasPermission(PermissionModule.Contratos, 4) && (
                                                                        <Button onClick={() => handleRemoveAlunoFromContrato(aluno.id, aluno.cursoId)} color="warning" title="Remover vínculo deste curso (não exclui o aluno)"><i className="fa-solid fa-link-slash"></i></Button>
                                                                    )}
                                                                    {hasPermission(PermissionModule.Contratos, 4) && (
                                                                        <Button onClick={() => handleDeleteAluno(aluno.id)} color="danger" title="Excluir aluno permanentemente do sistema"><i className="fa-solid fa-trash"></i></Button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            {expandedAlunoPhones.has(aluno.id) && (
                                                                <tr>
                                                                    <td colSpan={99}>
                                                                        {allVisibleAlunoDetailsExpanded ? (
                                                                            <div className="aluno-details-compact">
                                                                                <span>
                                                                                    <strong>Foto:</strong>
                                                                                    {aluno.base64Image ? (
                                                                                        <img src={aluno.base64Image} alt={`Foto de ${aluno.name}`} className="aluno-detail-photo-compact" />
                                                                                    ) : (
                                                                                        <span className="aluno-detail-photo-compact aluno-detail-photo-placeholder" />
                                                                                    )}
                                                                                </span>
                                                                                <span><strong>Nº:</strong> {aluno.addressNumber || "-"}</span>
                                                                                <span><strong>Bairro:</strong> {aluno.neighborhood || "-"}</span>
                                                                                <span><strong>Cidade:</strong> {aluno.city || "-"}</span>
                                                                                <span><strong>Estado:</strong> {aluno.state || "-"}</span>
                                                                                <span><strong>CEP:</strong> {aluno.zipCode || "-"}</span>
                                                                                <span><strong>Tel 02:</strong> {aluno.telephone_02 || "-"}</span>
                                                                                <span><strong>Tel 03:</strong> {aluno.telephone_03 || "-"}</span>
                                                                                <span><strong>Tel 04:</strong> {aluno.telephone_04 || "-"}</span>
                                                                                <span><strong>Tel 05:</strong> {aluno.telephone_05 || "-"}</span>
                                                                                <span><strong>Tel 06:</strong> {aluno.telephone_06 || "-"}</span>
                                                                                <span><strong>Facebook:</strong> {aluno.facebook || "-"}</span>
                                                                                <span><strong>Instagram:</strong> {aluno.instagram || "-"}</span>
                                                                            </div>
                                                                        ) : (
                                                                        <div className="aluno-details-grid">
                                                                            <div>
                                                                                <strong>Foto</strong>
                                                                                <div className="mt-2">
                                                                                    {aluno.base64Image ? (
                                                                                        <img src={aluno.base64Image} alt={`Foto de ${aluno.name}`} className="aluno-detail-photo" />
                                                                                    ) : (
                                                                                        <div className="aluno-detail-photo aluno-detail-photo-placeholder" />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <strong>Endereço</strong>
                                                                                <div>Nº: {aluno.addressNumber || "-"}</div>
                                                                                <div>Bairro: {aluno.neighborhood || "-"}</div>
                                                                                <div>Cidade: {aluno.city || "-"}</div>
                                                                                <div>Estado: {aluno.state || "-"}</div>
                                                                                <div>CEP: {aluno.zipCode || "-"}</div>
                                                                            </div>
                                                                            <div>
                                                                                <strong>Telefones extras</strong>
                                                                                <div>Telefone 02: {aluno.telephone_02 || "-"}</div>
                                                                                <div>Telefone 03: {aluno.telephone_03 || "-"}</div>
                                                                                <div>Telefone 04: {aluno.telephone_04 || "-"}</div>
                                                                                <div>Telefone 05: {aluno.telephone_05 || "-"}</div>
                                                                                <div>Telefone 06: {aluno.telephone_06 || "-"}</div>
                                                                            </div>
                                                                            <div>
                                                                                <strong>Redes sociais</strong>
                                                                                <div>Facebook: {aluno.facebook || "-"}</div>
                                                                                <div>Instagram: {aluno.instagram || "-"}</div>
                                                                            </div>
                                                                        </div>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            </React.Fragment>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <div style={{ color: "#8898aa", fontSize: "14px" }}>
                                                        {listAluno.length > 0 ? `Total de alunos: ${totalAlunos}` : ''}
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        {listAluno.length === 0 && (
                                                            <div style={{ color: "red", marginRight: "20px" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                                        )}
                                                        {alunoPageCount && (
                                                            <PaginationMaterial
                                                                onChange={(e: any, value: any) => onChangePaginationAluno(e, value)}
                                                                count={alunoPageCount}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row className="mt-4">
                                            <Col>
                                                <div style={{ color: "red", textAlign: "center" }}>
                                                    Você não tem permissão para visualizar os alunos.
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    </>
                                    )}
                                </TabPane>
                                <TabPane tabId="3">
                                    {loadingTab3 ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Carregando custos...</span>
                                            </div>
                                        </div>
                                    ) : (
                                    <>
                                    {hasPermission(PermissionModule.Contratos, 2) ? (
                                        <Row className="mt-3">
                                            <Col>
                                                {hasPermission(PermissionModule.Contratos, 1) && (
                                                    <Col xs="12" className="text-right mt-3">
                                                        <Button
                                                            color="primary"
                                                            onClick={() => exportCustoBytes(selectedContratoId, objUserTk.EmpresaId)}
                                                        >
                                                            <i className="fa-solid fa-file-pdf mr-2"></i> Exportar PDF
                                                        </Button>
                                                        <Button
                                                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                                                            className="btn-filter"
                                                            onClick={() => setCreateCustoModalOpen(true)}
                                                        >
                                                            Adicionar custo
                                                        </Button>
                                                    </Col>
                                                )}
                                                <Row className="mt-3">
                                                    <Col>
                                                        <Nav tabs className="mb-3">
                                                            <NavItem>
                                                                <NavLink
                                                                    className={classnames({ active: activeCustoTab === 'custo' })}
                                                                    onClick={() => setActiveCustoTab('custo')}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Custo
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem>
                                                                <NavLink
                                                                    className={classnames({ active: activeCustoTab === 'financeiro' })}
                                                                    onClick={() => setActiveCustoTab('financeiro')}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    Itens do Financeiro
                                                                </NavLink>
                                                            </NavItem>
                                                        </Nav>
                                                        <TabContent activeTab={activeCustoTab}>
                                                            <TabPane tabId="custo">
                                                        <Table hover responsive className="table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th>Sequência</th>
                                                                    <th>Descrição</th>
                                                                    <th>Tipo do custo</th>
                                                                    <th>Descrição do custo</th>
                                                                    <th>Valor</th>
                                                                    <th>Saldo</th>
                                                                    <th>Valor total</th>
                                                                    <th>Data de solicitação</th>
                                                                    <th>Data de entrega</th>
                                                                    <th>Data de pagamento</th>
                                                                    <th>Recebedor</th>
                                                                    <th>$</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {listCustoGeral.map((custoGeral: CustoType, index: number) => (
                                                                    <tr key={index}>
                                                                        <td>{custoGeral.id}</td>
                                                                        <td>{custoGeral.description}</td>
                                                                        <td>{custoGeral.tipoCustoIsFinancial == true ? "Financeiro" : "Custo"}</td>
                                                                        <td>{custoGeral.tipoCustoName}</td>
                                                                        <td>
                                                                            {custoGeral.individualValue?.toLocaleString("pt-BR", {
                                                                                style: "currency",
                                                                                currency: "BRL"
                                                                            })}
                                                                        </td>
                                                                        <td>{custoGeral.currentBalance?.toLocaleString("pt-BR")}</td>
                                                                        <td>{formatCurrency(getCustoTotalValue(custoGeral.individualValue, custoGeral.currentBalance, custoGeral.tipoCustoIsFixo))}</td>
                                                                        <td>{custoGeral.requestDate?.toString() ?? 'Ainda não definido'}</td>
                                                                        <td>{custoGeral.deliveryDate?.toString() ?? 'Ainda não definido'}</td>
                                                                        <td>{custoGeral.paymentDate?.toString() ?? 'Ainda não definido'}</td>
                                                                        <td>{custoGeral.receiver != "" ? custoGeral.receiver : 'Ainda não definido'}</td>
                                                                        <td>{custoGeral.hasReceiptAttachment ? '$' : ''}</td>
                                                                        <td>
                                                                            {custoGeral.tipoCustoIsFinancial == true && (
                                                                                <Button>Enviar para o financeiro</Button>
                                                                            )}
                                                                            {hasPermission(PermissionModule.Contratos, 3) && (
                                                                                // <Button onClick={() => handleEditCusto(custoGeral)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                                                <Button onClick={() => { setEditingCusto(custoGeral); setEditCustoModalOpen(true); }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                                            )}
                                                                            {hasPermission(PermissionModule.Contratos, 4) && (
                                                                                <Button onClick={() => handleDeleteCusto(custoGeral.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr className="bg-light font-weight-bold">
                                                                    <td colSpan={4} className="text-right">TOTAL</td>
                                                                    <td className="text-right">
                                                                        {totaisGeral.totalValor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                                                    </td>
                                                                    <td className="text-right">
                                                                        {totaisGeral.totalSaldo.toLocaleString("pt-BR")}
                                                                    </td>
                                                                    <td className="text-right">
                                                                        {totaisGeral.saldoFinal.toLocaleString("pt-BR", {
                                                                            style: "currency",
                                                                            currency: "BRL",
                                                                        })}
                                                                    </td>
                                                                    <td colSpan={6}></td>
                                                                </tr>
                                                            </tfoot>
                                                        </Table>
                                                        <div className="d-flex justify-content-end mt-3">
                                                            {custoGeralPageCount && (
                                                                <div className="d-flex justify-content-center mt-4">
                                                                    <PaginationMaterial
                                                                        onChange={(e: any, value: any) => onChangePaginationCustoGeral(e, value)}
                                                                        count={custoGeralPageCount}
                                                                    />
                                                                </div>
                                                            )}
                                                            {listCustoGeral.length === 0 && (
                                                                <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                                            )}
                                                        </div>
                                                            </TabPane>
                                                            <TabPane tabId="financeiro">

                                                        <Table hover responsive className="table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th>Sequência</th>
                                                                    <th>Descrição</th>
                                                                    <th>Tipo do custo</th>
                                                                    <th>Descrição do custo</th>
                                                                    <th>Valor</th>
                                                                    <th>Saldo</th>
                                                                    <th>Valor total</th>
                                                                    <th>Data de solicitação</th>
                                                                    <th>Data de entrega</th>
                                                                    <th>Data de pagamento</th>
                                                                    <th>Recebedor</th>
                                                                    <th>$</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {listCustoFinanceiro.map((custoFinanceiro: CustoType, index: number) => (
                                                                    <tr
                                                                        key={index}
                                                                        style={
                                                                            custoFinanceiro.hasReceiptAttachment
                                                                                ? { backgroundColor: "#d4edda" } // verde claro
                                                                                : undefined
                                                                        }
                                                                    >
                                                                        <td>{custoFinanceiro.id}</td>
                                                                        <td>{custoFinanceiro.description}</td>
                                                                        <td>{custoFinanceiro.tipoCustoIsFinancial == true ? "Financeiro" : "Custo"}</td>
                                                                        <td>{custoFinanceiro.tipoCustoName}</td>
                                                                        <td>
                                                                            {custoFinanceiro.individualValue?.toLocaleString("pt-BR", {
                                                                                style: "currency",
                                                                                currency: "BRL",
                                                                            })}
                                                                        </td>
                                                                        <td>{custoFinanceiro.currentBalance?.toLocaleString("pt-BR")}</td>
                                                                        <td>{formatCurrency(getCustoTotalValue(custoFinanceiro.individualValue, custoFinanceiro.currentBalance, custoFinanceiro.tipoCustoIsFixo))}</td>

                                                                        <td>{custoFinanceiro.requestDate?.toString() ?? "Ainda não definido"}</td>
                                                                        <td>{custoFinanceiro.deliveryDate?.toString() ?? "Ainda não definido"}</td>
                                                                        <td>{custoFinanceiro.paymentDate?.toString() ?? "Ainda não definido"}</td>
                                                                        <td>{custoFinanceiro.receiver != "" ? custoFinanceiro.receiver : "Ainda não definido"}</td>
                                                                        <td>{custoFinanceiro.hasReceiptAttachment ? "$" : ""}</td>

                                                                        <td>
                                                                            {custoFinanceiro.tipoCustoIsFinancial === true && (
                                                                                custoFinanceiro.isPaid ? (
                                                                                    <Button color="success" disabled>
                                                                                        <i className="fa-solid fa-check mr-1"></i> Enviado
                                                                                    </Button>
                                                                                ) : (
                                                                                    <Button
                                                                                        color="primary"
                                                                                        onClick={() => handleEnviarParaFinanceiro(custoFinanceiro.id)}
                                                                                    >
                                                                                        <i className="fa-solid fa-paper-plane mr-1"></i> Enviar para o financeiro
                                                                                    </Button>
                                                                                )
                                                                            )}

                                                                            {hasPermission(PermissionModule.Contratos, 3) && (
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        setEditingCusto(custoFinanceiro);
                                                                                        setEditCustoModalOpen(true);
                                                                                    }}
                                                                                >
                                                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                                                </Button>
                                                                            )}

                                                                            {hasPermission(PermissionModule.Contratos, 4) && (
                                                                                <Button onClick={() => handleDeleteCusto(custoFinanceiro.id)} color="danger">
                                                                                    <i className="fa-solid fa-trash"></i>
                                                                                </Button>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>

                                                            <tfoot>
                                                                <tr className="bg-light font-weight-bold">
                                                                    <td colSpan={4} className="text-right">
                                                                        TOTAL
                                                                    </td>
                                                                    <td className="text-right">
                                                                        {totaisFinanceiro.totalValor.toLocaleString("pt-BR", {
                                                                            style: "currency",
                                                                            currency: "BRL",
                                                                        })}
                                                                    </td>
                                                                    <td className="text-right">{totaisFinanceiro.totalSaldo.toLocaleString("pt-BR")}</td>
                                                                    <td className="text-right">
                                                                        {totaisFinanceiro.saldoFinal.toLocaleString("pt-BR", {
                                                                            style: "currency",
                                                                            currency: "BRL",
                                                                        })}
                                                                    </td>
                                                                    <td colSpan={6}></td>
                                                                </tr>
                                                            </tfoot>
                                                        </Table>

                                                        <div className="d-flex justify-content-end mt-3">
                                                            {custoFinanceiroPageCount && (
                                                                <div className="d-flex justify-content-center mt-4">
                                                                    <PaginationMaterial
                                                                        onChange={(e: any, value: any) => onChangePaginationCustoFinanceiro(e, value)}
                                                                        count={custoFinanceiroPageCount}
                                                                    />
                                                                </div>
                                                            )}

                                                            {listCustoFinanceiro.length === 0 && (
                                                                <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                                            )}
                                                        </div>
                                                            </TabPane>
                                                        </TabContent>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row className="mt-4">
                                            <Col>
                                                <div style={{ color: "red", textAlign: "center" }}>
                                                    Você não tem permissão para visualizar os custos.
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    </>
                                    )}
                                </TabPane>
                                <TabPane tabId="4">
                                    {loadingTab4 ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Carregando eventos...</span>
                                            </div>
                                        </div>
                                    ) : (
                                    <>
                                    <Row className="align-items-center mb-4 mt-4">
                                        <Col xs="12" md="2">
                                            <Label className="form-control-label">Data inicial</Label>
                                            <Input
                                                type="date"
                                                value={customStartDate}
                                                onChange={e => setCustomStartDate(e.target.value)}
                                                className="form-control-alternative"
                                            />
                                        </Col>

                                        <Col xs="12" md="2">
                                            <Label className="form-control-label">Data final</Label>
                                            <Input
                                                type="date"
                                                value={customEndDate}
                                                onChange={e => setCustomEndDate(e.target.value)}
                                                className="form-control-alternative"
                                            />
                                        </Col>

                                        <Col xs="12" md="4">
                                            <FormGroup>
                                                <Label className="form-control-label">Selecionar eventos específicos</Label>
                                                <Select
                                                    isMulti
                                                    options={options}
                                                    value={options.filter(o => selectedAgendaIds.includes(o.value))}
                                                    onChange={handleMultiSelectChange}
                                                    placeholder="Digite para buscar eventos..."
                                                    className="form-control-alternative"
                                                    classNamePrefix="select"
                                                    styles={{
                                                        menu: base => ({ ...base, zIndex: 9999 }),
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col xs="12" md="4" className="d-flex justify-content-md-end">
                                            <Button
                                                style={{ background: "#585858", color: "#FFF" }}
                                                onClick={handlePrintPdf}
                                            >
                                                Imprimir PDF por Período/Eventos
                                            </Button>
                                            <Button
                                                className="ml-2"
                                                style={{ background: "#585858", color: "#FFF" }}
                                                onClick={handleDownloadPdf}
                                            >
                                                Baixar PDF por Período/Eventos
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className="mt-5">
                                        <Col>
                                            <DnDCalendar
                                                localizer={localizer}
                                                events={events}
                                                startAccessor={(event: any) => new Date(event.start)}
                                                endAccessor={(event: any) => new Date(event.end)}
                                                selectable
                                                onSelectSlot={handleSelectSlot}
                                                onSelectEvent={handleSelectEvent}
                                                onEventDrop={handleEventDrop}
                                                resizable
                                                messages={messages}
                                                view={currentView}
                                                onView={(view) => setCurrentView(view)}
                                                views={{ month: true, week: true, day: true, agenda: true }}
                                                date={currentView === 'agenda' ? agendaBaseDate : undefined}
                                                length={10000}
                                                formats={{
                                                    agendaDateFormat: (date, culture, localizer) =>
                                                        moment(date).format('dddd, DD [de] MMMM [de] YYYY'),
                                                    agendaTimeFormat: 'HH:mm',
                                                    timeGutterFormat: 'HH:mm',
                                                }}
                                                style={{ height: 500 }}
                                                components={{
                                                    agenda: {
                                                        event: CustomAgendaEvent
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    </>
                                    )}
                                </TabPane>
                                <TabPane tabId="5">
                                    {loadingTab5 ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Carregando observações...</span>
                                            </div>
                                        </div>
                                    ) : (
                                    <>
                                    {hasPermission(PermissionModule.Contratos, 2) ? (
                                        <Row className="mt-4">
                                            <Col>
                                                {hasPermission(PermissionModule.Contratos, 1) && (
                                                    <Col xs="12" className="text-right mt-3">
                                                        <Button
                                                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                                                            className="btn-filter"
                                                            onClick={() => {
                                                                setCreateObservacaoContratoModalOpen(true);
                                                            }}
                                                        >
                                                            Adicionar observação
                                                        </Button>
                                                    </Col>
                                                )}
                                                <Table hover responsive className="table-striped mt-4">
                                                    <thead>
                                                        <tr>
                                                            <th>Sequência</th>
                                                            <th>Observação</th>
                                                            <th>Data</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {listObservacaoContrato.map((observacaoContrato: ObservacaoContratoType, index: number) => (
                                                            <tr key={index}>
                                                                <td>{observacaoContrato.id}</td>
                                                                <td>{observacaoContrato.observation}</td>
                                                                <td>{new Date(observacaoContrato.date).toLocaleDateString('pt-BR')}</td>
                                                                <td>
                                                                    {hasPermission(PermissionModule.Contratos, 3) && (
                                                                        <Button onClick={() => handleEditObservacaoContrato(observacaoContrato)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                                    )}
                                                                    {hasPermission(PermissionModule.Contratos, 4) && (
                                                                        <Button onClick={() => handleDeleteObservacaoContrato(observacaoContrato.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                <div className="d-flex justify-content-end mt-3">
                                                    {observacaoContratoPageCount && (
                                                        <div className="d-flex justify-content-center mt-4">
                                                            <PaginationMaterial
                                                                onChange={(e: any, value: any) => onChangePaginationObservacaoContrato(e, value)}
                                                                count={observacaoContratoPageCount}
                                                            />
                                                        </div>
                                                    )}
                                                    {listObservacaoContrato.length === 0 && (
                                                        <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row className="mt-4">
                                            <Col>
                                                <div style={{ color: "red", textAlign: "center" }}>
                                                    Você não tem permissão para visualizar as observações.
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    </>
                                    )}
                                </TabPane>
                            </TabContent>
                        </>
                    )}
                </ModalBody>
            </Modal >

            <Modal
                isOpen={createPreparacaoAlbumModalOpen}
                toggle={() => setCreatePreparacaoAlbumModalOpen(!createPreparacaoAlbumModalOpen)}
                backdrop="static"
                size="xl"
            >
                <ModalHeader toggle={() => setCreatePreparacaoAlbumModalOpen(!createPreparacaoAlbumModalOpen)}>
                    Adicionar Preparação de Álbum
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreatePreparacaoAlbum}>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="description">
                                        Descrição
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="description"
                                        id="description"
                                        value={newPreparacaoAlbum.description}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                        placeholder="Ex: Álbum infantil 2023"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfAlbums">
                                        Cursos do Contrato
                                    </Label>
                                    <div className="mt-2">
                                        {listCursoByContrato.map((curso) => (
                                            <span key={curso.id} className="badge badge-primary mr-2">
                                                {curso.name}
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger ml-1"
                                                    onClick={() => {
                                                        const novoArray = listCursoByContrato.filter((c) => c.id !== curso.id);
                                                        setListCursoByContrato(novoArray);
                                                    }}
                                                >
                                                    x
                                                </button>
                                            </span>
                                        ))}
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="editorId">Editor</Label>
                                    <InputGroup>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="editorId"
                                            id="editorId"
                                            value={newPreparacaoAlbum.editorId}
                                            onChange={handleCreatePreparacaoAlbumInputChange}
                                        >
                                            <option value={0}>Selecione um Editor</option>
                                            {listEditor.map((editor) => (
                                                <option key={editor.id} value={editor.id}>
                                                    {editor.name}
                                                </option>
                                            ))}
                                        </Input><Button
                                                style={{ background: '#585858', color: '#fff' }}
                                                onClick={() => setCreateEditorModalOpen(true)}
                                            >
                                                +
                                            </Button></InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="editorDeliveryDate">
                                        Entrega para o editor
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="editorDeliveryDate"
                                        id="editorDeliveryDate"
                                        value={newPreparacaoAlbum.editorDeliveryDate?.toString() || ""}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="editorReturnDate">
                                        Retorno do Editor
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="editorReturnDate"
                                        id="editorReturnDate"
                                        value={newPreparacaoAlbum.editorReturnDate?.toString() || ""}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                        disabled={newPreparacaoAlbum.editorId === 0}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfPhotos">
                                        Nº de Fotos do Editor
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="numberOfPhotos"
                                        id="numberOfPhotos"
                                        value={newPreparacaoAlbum.numberOfPhotos}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="laboratorioId">
                                        Laboratório
                                    </Label>
                                    <InputGroup>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="laboratorioId"
                                            id="laboratorioId"
                                            value={newPreparacaoAlbum.laboratorioId}
                                            onChange={handleCreatePreparacaoAlbumInputChange}
                                            disabled={!newPreparacaoAlbum.editorReturnDate}
                                        >
                                            <option value={0}>Selecione um Laboratório</option>
                                            {listLaboratory.map((lab) => (
                                                <option key={lab.id} value={lab.id}>
                                                    {lab.name}
                                                </option>
                                            ))}
                                        </Input><Button
                                                style={{ background: '#585858', color: '#fff' }}
                                                onClick={() => setCreateLabModalOpen(true)}
                                                disabled={!newPreparacaoAlbum.editorReturnDate}
                                            >
                                                +
                                            </Button></InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="laboratoryDeliveryDate">
                                        Entrega no Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="laboratoryDeliveryDate"
                                        id="laboratoryDeliveryDate"
                                        value={newPreparacaoAlbum.laboratoryDeliveryDate?.toString() || ""}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                        disabled={!newPreparacaoAlbum.editorReturnDate}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="laboratoryReturnDate">
                                        Retorno do Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="laboratoryReturnDate"
                                        id="laboratoryReturnDate"
                                        value={newPreparacaoAlbum.laboratoryReturnDate?.toString() || ""}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                        disabled={newPreparacaoAlbum.laboratorioId === 0}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfPhotosLaboratory">
                                        Nº de Fotos do Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="numberOfPhotosLaboratory"
                                        id="numberOfPhotosLaboratory"
                                        value={newPreparacaoAlbum.numberOfPhotosLaboratory}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="numberOfAlbums">
                                        Nº de Álbuns do Laboratório
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="numberOfAlbums"
                                        id="numberOfAlbums"
                                        value={newPreparacaoAlbum.numberOfAlbums}
                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-4">
                            <Col md="12">
                                <div style={{ border: '1px solid #ccc', borderRadius: 10, padding: 15, boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
                                    <h5 className="mb-3">Kits Disponíveis</h5>
                                    <Row>
                                        <Col md="4">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="kit30x60"
                                                        checked={newPreparacaoAlbum.kit30x60}
                                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                                    />{' '}
                                                    Kit 30x60
                                                </Label>
                                                <Input
                                                    className="form-control-alternative mt-2"
                                                    type="number"
                                                    name="kit30x60Quantities"
                                                    value={newPreparacaoAlbum.kit30x60Quantities}
                                                    onChange={handleCreatePreparacaoAlbumInputChange}
                                                    placeholder="Quantidade"
                                                    disabled={!newPreparacaoAlbum.kit30x60}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="kit10x15"
                                                        checked={newPreparacaoAlbum.kit10x15}
                                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                                    />{' '}
                                                    Kit 10x15
                                                </Label>
                                                <Input
                                                    className="form-control-alternative mt-2"
                                                    type="number"
                                                    name="kit10x15Quantities"
                                                    value={newPreparacaoAlbum.kit10x15Quantities}
                                                    onChange={handleCreatePreparacaoAlbumInputChange}
                                                    placeholder="Quantidade"
                                                    disabled={!newPreparacaoAlbum.kit10x15}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup check>
                                                <Label check>
                                                    <Input
                                                        type="checkbox"
                                                        name="kit28x35"
                                                        checked={newPreparacaoAlbum.kit28x35}
                                                        onChange={handleCreatePreparacaoAlbumInputChange}
                                                    />{' '}
                                                    Kit 28x35
                                                </Label>
                                                <Input
                                                    className="form-control-alternative mt-2"
                                                    type="number"
                                                    name="kit28x35Quantities"
                                                    value={newPreparacaoAlbum.kit28x35Quantities}
                                                    onChange={handleCreatePreparacaoAlbumInputChange}
                                                    placeholder="Quantidade"
                                                    disabled={!newPreparacaoAlbum.kit28x35}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="status">
                                        Status do contrato
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="status"
                                        id="status"
                                        value={selectedContract ? getStatusLabel(Number(selectedContract.status)) : 'Status não definido'}
                                        disabled
                                    >
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                type="submit"
                                size="m"
                            >
                                Criar Preparação
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                className="ml-2"
                                onClick={() => { setCreatePreparacaoAlbumModalOpen(false); getAllContratoPaged(1, 9, "", objUserTk.EmpresaId); }}
                                size="m"
                            >
                                Cancelar
                            </Button>
                        </div>
                    </Form>
                    <hr />
                    <h4 className="mt-3">Itens já cadastrados</h4>
                    <Table hover responsive className="table-striped">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Descrição</th>
                                <th>Cursos</th>
                                <th>Fotos</th>
                                <th>Álbuns</th>
                                <th>Entrega Editor</th>
                                <th>Retorno Editor</th>
                                <th>Entrega Lab</th>
                                <th>Retorno Lab</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listPreparacaoAlbum.map(item => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.description}</td>
                                    <td>
                                        {item.cursos?.length ? (
                                            item.cursos.map((curso) => curso.name).join(", ")
                                        ) : (
                                            "Nenhum curso"
                                        )}
                                    </td>
                                    <td>{item.numberOfPhotos}</td>
                                    <td>{item.numberOfAlbums}</td>
                                    <td>{item.editorDeliveryDate ? item.editorDeliveryDate : "Data ainda não definida"}</td>
                                    <td>{item.editorReturnDate ? item.editorReturnDate : "Data ainda não definida"}</td>
                                    <td>{item.laboratoryDeliveryDate ? item.laboratoryDeliveryDate : "Data ainda não definida"}</td>
                                    <td>{item.laboratoryReturnDate ? item.laboratoryReturnDate : "Data ainda não definida"}</td>
                                    <td>{getPreparacaoStatusLabel(Number(item.status))}</td>
                                    <td>
                                        <Button onClick={() => handleEditPreparacaoAlbum(item)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                        <Button onClick={() => handleDeletePreparacaoAlbum(item.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <div className="d-flex justify-content-end mt-3">
                        {preparacaoAlbumPageCount && (
                            <div className="d-flex justify-content-center mt-4">
                                <PaginationMaterial
                                    onChange={(e: any, value: any) => onChangePaginationPreparacaoAlbum(e, value)}
                                    count={preparacaoAlbumPageCount}
                                />
                            </div>
                        )}
                        {listPreparacaoAlbum.length === 0 && (
                            <div style={{ color: "red" }}>Não há preparações de álbum cadastradas.</div>
                        )}
                    </div>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={editPreparacaoAlbumModalOpen}
                toggle={() => setEditPreparacaoAlbumModalOpen(!editPreparacaoAlbumModalOpen)}
                backdrop="static"
                size="xl"
            >
                <ModalHeader toggle={() => setEditPreparacaoAlbumModalOpen(!editPreparacaoAlbumModalOpen)}>
                    Editar Preparação de Álbum
                </ModalHeader>
                <ModalBody>
                    {editingPreparacaoAlbum && (
                        <Form onSubmit={handleEditPreparacaoAlbumSubmit}>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="description">
                                            Descrição
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="text"
                                            name="description"
                                            id="description"
                                            value={editingPreparacaoAlbum.description}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="cursoBadge">
                                            Cursos vinculados
                                        </Label>
                                        <div className="mt-2" id="cursoBadge">
                                            {editingPreparacaoAlbum.cursos?.map((curso) => (
                                                <span key={curso.id} className="badge badge-primary mr-2">
                                                    {curso.name}
                                                </span>
                                            ))}
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="editorId">
                                            Editor
                                        </Label>
                                        <InputGroup>
                                            <Input
                                                className="form-control-alternative"
                                                type="select"
                                                name="editorId"
                                                id="editorId"
                                                value={editingPreparacaoAlbum.editorId}
                                                onChange={handleEditPreparacaoAlbumInputChange}
                                            >
                                                <option value={0}>Selecione um Editor</option>
                                                {listEditor.map((editor) => (
                                                    <option key={editor.id} value={editor.id}>
                                                        {editor.name}
                                                    </option>
                                                ))}
                                            </Input><Button
                                                    style={{ background: '#585858', color: '#fff' }}
                                                    onClick={() => setCreateEditorModalOpen(true)}
                                                >
                                                    +
                                                </Button></InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="editorDeliveryDate">
                                            Entrega para o editor
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="editorDeliveryDate"
                                            id="editorDeliveryDate"
                                            value={editingPreparacaoAlbum.editorDeliveryDate?.toString() || ""}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="editorReturnDate">
                                            Retorno do Editor
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="editorReturnDate"
                                            id="editorReturnDate"
                                            value={editingPreparacaoAlbum.editorReturnDate?.toString() || ""}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                            disabled={editingPreparacaoAlbum.editorId === 0}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberOfPhotos">
                                            Nº de Fotos do Editor
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberOfPhotos"
                                            id="numberOfPhotos"
                                            value={editingPreparacaoAlbum.numberOfPhotos}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="laboratorioId">
                                            Laboratório
                                        </Label>
                                        <InputGroup>
                                            <Input
                                                className="form-control-alternative"
                                                type="select"
                                                name="laboratorioId"
                                                id="laboratorioId"
                                                value={editingPreparacaoAlbum.laboratorioId}
                                                onChange={handleEditPreparacaoAlbumInputChange}
                                                disabled={!editingPreparacaoAlbum.editorReturnDate}
                                            >
                                                <option value={0}>Selecione um Laboratório</option>
                                                {listLaboratory.map((lab) => (
                                                    <option key={lab.id} value={lab.id}>
                                                        {lab.name}
                                                    </option>
                                                ))}
                                            </Input><Button
                                                    style={{ background: '#585858', color: '#fff' }}
                                                    onClick={() => setCreateLabModalOpen(true)}
                                                    disabled={!editingPreparacaoAlbum.editorReturnDate}
                                                >
                                                    +
                                                </Button></InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="laboratoryDeliveryDate">
                                            Entrega no Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="laboratoryDeliveryDate"
                                            id="laboratoryDeliveryDate"
                                            value={editingPreparacaoAlbum.laboratoryDeliveryDate?.toString() || ""}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                            disabled={!editingPreparacaoAlbum.editorReturnDate}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="laboratoryReturnDate">
                                            Retorno do Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="laboratoryReturnDate"
                                            id="laboratoryReturnDate"
                                            value={editingPreparacaoAlbum.laboratoryReturnDate?.toString() || ""}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                            disabled={editingPreparacaoAlbum.laboratorioId === 0}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberOfPhotosLaboratory">
                                            Nº de Fotos do Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberOfPhotosLaboratory"
                                            id="numberOfPhotosLaboratory"
                                            value={editingPreparacaoAlbum.numberOfPhotosLaboratory}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberOfAlbums">
                                            Nº de Álbuns do Laboratório
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberOfAlbums"
                                            id="numberOfAlbums"
                                            value={editingPreparacaoAlbum.numberOfAlbums}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-4">
                                <Col md="12">
                                    <div style={{ border: '1px solid #ccc', borderRadius: 10, padding: 15, boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
                                        <h5 className="mb-3">Kits Disponíveis</h5>
                                        <Row>
                                            <Col md="4">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            name="kit30x60"
                                                            checked={editingPreparacaoAlbum.kit30x60}
                                                            onChange={handleEditPreparacaoAlbumInputChange}
                                                        />{' '}
                                                        Kit 30x60
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative mt-2"
                                                        type="number"
                                                        name="kit30x60Quantities"
                                                        value={editingPreparacaoAlbum.kit30x60Quantities}
                                                        onChange={handleEditPreparacaoAlbumInputChange}
                                                        placeholder="Quantidade"
                                                        disabled={!editingPreparacaoAlbum.kit30x60}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            name="kit10x15"
                                                            checked={editingPreparacaoAlbum.kit10x15}
                                                            onChange={handleEditPreparacaoAlbumInputChange}
                                                        />{' '}
                                                        Kit 10x15
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative mt-2"
                                                        type="number"
                                                        name="kit10x15Quantities"
                                                        value={editingPreparacaoAlbum.kit10x15Quantities}
                                                        onChange={handleEditPreparacaoAlbumInputChange}
                                                        placeholder="Quantidade"
                                                        disabled={!editingPreparacaoAlbum.kit10x15}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="4">
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input
                                                            type="checkbox"
                                                            name="kit28x35"
                                                            checked={editingPreparacaoAlbum.kit28x35}
                                                            onChange={handleEditPreparacaoAlbumInputChange}
                                                        />{' '}
                                                        Kit 28x35
                                                    </Label>
                                                    <Input
                                                        className="form-control-alternative mt-2"
                                                        type="number"
                                                        name="kit28x35Quantities"
                                                        value={editingPreparacaoAlbum.kit28x35Quantities}
                                                        onChange={handleEditPreparacaoAlbumInputChange}
                                                        placeholder="Quantidade"
                                                        disabled={!editingPreparacaoAlbum.kit28x35}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="status">
                                            Status do Álbum
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="status"
                                            id="status"
                                            value={editingPreparacaoAlbum.status}
                                            onChange={handleEditPreparacaoAlbumInputChange}
                                        >
                                            <option value={0}>Selecione...</option>
                                            <option value={1}>Aberto</option>
                                            <option value={2}>Em andamento</option>
                                            <option value={3}>Em edição</option>
                                            <option value={4}>Em laboratório</option>
                                            <option value={5}>Finalizado</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    type="submit"
                                    size="m"
                                >
                                    Salvar alterações
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                    className="ml-2"
                                    onClick={() => setEditPreparacaoAlbumModalOpen(false)}
                                    size="m"
                                >
                                    Cancelar
                                </Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>
            <Modal isOpen={createObservacaoContratoModalOpen} toggle={() => setCreateObservacaoContratoModalOpen(false)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setCreateObservacaoContratoModalOpen(false)}>Nova Observação</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreateObservacaoContrato}>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="observation">Observação</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="textarea"
                                        name="observation"
                                        id="observation"
                                        value={newObservacaoContrato.observation}
                                        placeholder="Observação"
                                        onChange={handleCreateObservacaoContratoInputChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="date">Data</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="date"
                                        id="date"
                                        value={newObservacaoContrato.date}
                                        placeholder="Data"
                                        onChange={handleCreateObservacaoContratoInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-4">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                            <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={() => setCreateObservacaoContratoModalOpen(false)} size="m">Cancelar</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
            <Modal isOpen={editObservacaoContratoModalOpen} toggle={() => setEditObservacaoContratoModalOpen(false)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setEditObservacaoContratoModalOpen(false)}>Editar Observação</ModalHeader>
                <ModalBody>
                    {editingObservacaoContrato && (
                        <Form onSubmit={handleEditObservacaoContratoSubmit}>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="observation">Observação</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="textarea"
                                            name="observation"
                                            id="observation"
                                            value={editingObservacaoContrato.observation}
                                            placeholder="Observação"
                                            onChange={handleEditObservacaoContratoInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="date">Data</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="date"
                                            id="date"
                                            value={editingObservacaoContrato.date}
                                            placeholder="Data"
                                            onChange={handleEditObservacaoContratoInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-4">
                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={() => setEditObservacaoContratoModalOpen(false)} size="m">Cancelar</Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>

            <CreateAlunoModal
                isOpen={createAlunoModalOpen}
                toggle={() => setCreateAlunoModalOpen(false)}
                contratoId={selectedContratoId}
                onAlunoCriado={() => {
                    const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
                    getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
                }}
            />

            <EditAlunoModal
                isOpen={editAlunoModalOpen}
                toggle={() => setEditAlunoModalOpen(false)}
                aluno={editingAluno}
                onAlunoAtualizado={() => {
                    const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
                    getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
                }}
            />

            <AlunosSemVinculoModal
                isOpen={alunosSemVinculoModalOpen}
                toggle={() => setAlunosSemVinculoModalOpen(false)}
                contratoId={selectedContratoId}
                cursosDoContrato={listCursoByContrato}
                onRevinculado={() => {
                    const parsedRef = parseInt(referenceCodeFiltroAlunos, 10);
                    getAlunoPaged(1, selectedContratoId, 9, undefined, undefined, selectedCursoFiltroAlunos?.value, isNaN(parsedRef) ? undefined : parsedRef);
                }}
            />

            <ModalConfirm
                openModal={pendingDelete !== null}
                closeModal={closeDeleteModal}
                handleConfirm={executeDelete}
                title={pendingDelete?.force ? `${pendingDelete.title} (contém dependentes)` : (pendingDelete?.title ?? "Confirmar exclusão")}
                message={pendingDelete?.force
                    ? `${pendingDelete.message} Este registro possui dependentes vinculados que também serão apagados em cascata, sem possibilidade de desfazer.`
                    : (pendingDelete?.message ?? "")}
                confirmButtonLabel={pendingDelete?.force ? "Excluir mesmo assim" : "Excluir"}
                loading={deleteLoading}
                confirmWord={
                    pendingDelete && ["contrato", "aluno", "removerCursoDoContrato"].includes(pendingDelete.type)
                        ? "EXCLUIR"
                        : undefined
                }
            />

            <CreateCustoModal
                isOpen={createCustoModalOpen}
                toggle={() => setCreateCustoModalOpen(!createCustoModalOpen)}
                selectedContratoId={selectedContratoId}
            />

            <EditCustoModal
                isOpen={editCustoModalOpen}
                toggle={() => setEditCustoModalOpen(false)}
                custo={editingCusto}
                selectedContratoId={selectedContratoId}
            />

            <CreateInstituicaoModal
                isOpen={createInstituicaoModalOpen}
                toggle={() => setCreateInstituicaoModalOpen(false)}
                onInstituicaoCriada={(id) => {
                    setNewContrato(prev => ({ ...prev, instituicaoId: id }));
                }}
            />

            <CreateCursoModal
                isOpen={createCursoModalOpen}
                toggle={() => setCreateCursoModalOpen(false)}
                onCursoCriado={() => handleGetCursoByEmpresaId(objUserTk.EmpresaId)}
            />

            <CreateTerceiroModal
                isOpen={createVendedorModalOpen}
                toggle={() => setCreateVendedorModalOpen(false)}
                // fixedTipoTerceiroId={5}                    // 5 = Representante Comercial (HML)
                fixedTipoTerceiroId={4}                    // 5 = Representante Comercial (PRD)
                onCreated={() => {
                    handleGetVendedoresByEmpresa(objUserTk.EmpresaId); setCreateVendedorModalOpen(false);
                }}
            />

            <CreateTerceiroModal
                isOpen={createEditorModalOpen}
                toggle={() => setCreateEditorModalOpen(false)}
                fixedTipoTerceiroId={12}              // 12 = Editor
                onCreated={() => {
                    handleGetEditorsByEmpresa(objUserTk.EmpresaId);
                    setCreateEditorModalOpen(false);
                }}
            />

            <CreateTerceiroModal
                isOpen={createLabModalOpen}
                toggle={() => setCreateLabModalOpen(false)}
                fixedTipoTerceiroId={14}              // 13/14 = Laboratório
                onCreated={() => {
                    handleGetLaboratoriesByEmpresa(objUserTk.EmpresaId);
                    setCreateLabModalOpen(false);
                }}
            />


            <CreateAgendaModal
                isOpen={createAgendaModalOpen}
                toggle={() => setCreateAgendaModalOpen(false)}
                contratoId={selectedContratoId}
                defaultStart={slotStart}
                defaultEnd={slotEnd}
                onCreated={refreshAgenda}
            />

            <EditAgendaModal
                isOpen={editAgendaModalOpen}
                toggle={() => setEditAgendaModalOpen(false)}
                agenda={editingAgenda}
                onUpdated={refreshAgenda}
                onDeleted={refreshAgenda}
            />

            <Modal
                isOpen={copyTransferModalOpen}
                toggle={() => {
                    setCopyTransferModalOpen(false);
                    resetCopyTransferModal();
                }}
                size="lg"
                backdrop="static"
            >
                <ModalHeader
                    toggle={() => {
                        setCopyTransferModalOpen(false);
                        resetCopyTransferModal();
                    }}
                >
                    Copiar / Transferir Alunos
                </ModalHeader>

                <ModalBody>
                    <Alert
                        color="info"
                        style={{
                            borderRadius: 8,
                            padding: "14px 16px",
                            marginBottom: 18,
                            backgroundColor: "#35D3F0",
                            borderColor: "#35D3F0",
                            color: "#fff",
                        }}
                    >
                        Selecionados: <strong>{selectedAlunosIds.length}</strong> aluno(s)
                    </Alert>

                    <Row>
                        <Col md={4}>
                            <FormGroup style={{ marginBottom: 18 }}>
                                <Label style={{ fontWeight: 600, marginBottom: 10 }}>Modo</Label>

                                <div
                                    className="d-flex align-items-center"
                                    style={{
                                        gap: 18,
                                        minHeight: 38,
                                    }}
                                >
                                    <Label
                                        className="mb-0 d-flex align-items-center"
                                        style={{
                                            gap: 8,
                                            cursor: targetContratoId === selectedContratoId ? "not-allowed" : "pointer",
                                            userSelect: "none",
                                            opacity: targetContratoId === selectedContratoId ? 0.5 : 1,
                                        }}
                                    >
                                        <Input
                                            type="radio"
                                            name="copyTransferMode"
                                            checked={copyTransferMode === "copy"}
                                            disabled={targetContratoId === selectedContratoId}
                                            onChange={() => setCopyTransferMode("copy")}
                                            style={{
                                                margin: 0,
                                                width: 16,
                                                height: 16,
                                                cursor: targetContratoId === selectedContratoId ? "not-allowed" : "pointer",
                                            }}
                                        />
                                        <span style={{ lineHeight: "16px", marginLeft: 20 }}>Copiar</span>
                                    </Label>

                                    <Label
                                        className="mb-0 d-flex align-items-center"
                                        style={{ gap: 8, cursor: "pointer", userSelect: "none" }}
                                    >
                                        <Input
                                            type="radio"
                                            name="copyTransferMode"
                                            checked={copyTransferMode === "transfer"}
                                            onChange={() => setCopyTransferMode("transfer")}
                                            style={{
                                                margin: 0,
                                                width: 16,
                                                height: 16,
                                                cursor: "pointer",
                                            }}
                                        />
                                        <span style={{ lineHeight: "16px", marginLeft: 20 }}>Transferir</span>
                                    </Label>
                                </div>
                            </FormGroup>
                        </Col>

                        <Col md={4}>
                            <FormGroup style={{ marginBottom: 18 }}>
                                <Label style={{ fontWeight: 600, marginBottom: 10 }}>Contrato destino</Label>

                                <Select
                                    options={allContratosForModal.map((c) => ({
                                        value: c.id,
                                        label: `#${c.id} - ${c.description}${c.id === selectedContratoId ? " (Mesmo contrato)" : ""}`,
                                    }))}
                                    value={
                                        targetContratoId
                                            ? {
                                                value: targetContratoId,
                                                label:
                                                    `#${targetContratoId} - ` +
                                                    (allContratosForModal.find((c) => c.id === targetContratoId)?.description ??
                                                     listContrato.find((c) => c.id === targetContratoId)?.description ?? "") +
                                                    (targetContratoId === selectedContratoId ? " (Mesmo contrato)" : ""),
                                            }
                                            : null
                                    }
                                    onChange={(opt: any) => handleTargetContratoChange(opt ? Number(opt.value) : 0)}
                                    isClearable
                                    isSearchable
                                    placeholder="Selecione..."
                                    classNamePrefix="react-select"
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: 38,
                                            height: 38,
                                            borderRadius: 6,
                                            borderColor: "#d0d7de",
                                            boxShadow: "none",
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: 38,
                                            padding: "0 10px",
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: 38,
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            color: "#8a94a6",
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                            </FormGroup>
                        </Col>

                        <Col md={4}>
                            <FormGroup style={{ marginBottom: 18 }}>
                                <Label style={{ fontWeight: 600, marginBottom: 10 }}>
                                    Curso destino {targetContratoId === selectedContratoId && <span className="text-danger">*</span>}
                                </Label>

                                <Select
                                    options={targetCursosList.map((c) => ({ value: c.id, label: c.name }))}
                                    value={
                                        targetCursoId
                                            ? {
                                                value: targetCursoId,
                                                label: targetCursosList.find((c) => c.id === targetCursoId)?.name ?? "",
                                            }
                                            : null
                                    }
                                    onChange={(opt: any) => setTargetCursoId(opt ? Number(opt.value) : 0)}
                                    isLoading={isTargetCursosLoading}
                                    isDisabled={!targetContratoId || isTargetCursosLoading}
                                    isClearable={targetContratoId !== selectedContratoId}
                                    isSearchable
                                    placeholder={
                                        !targetContratoId
                                            ? "Selecione o contrato..."
                                            : isTargetCursosLoading
                                            ? "Carregando cursos..."
                                            : targetContratoId === selectedContratoId
                                            ? "Selecione o novo curso..."
                                            : "Manter mesmos cursos ou escolher..."
                                    }
                                    classNamePrefix="react-select"
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: 38,
                                            height: 38,
                                            borderRadius: 6,
                                            borderColor: "#d0d7de",
                                            boxShadow: "none",
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: 38,
                                            padding: "0 10px",
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: 38,
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            color: "#8a94a6",
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div
                        className="d-flex justify-content-end"
                        style={{
                            gap: 16,
                            marginTop: 8,
                        }}
                    >
                        <Button
                            color="secondary"
                            onClick={() => {
                                setCopyTransferModalOpen(false);
                                resetCopyTransferModal();
                            }}
                            disabled={isCopyTransferLoading}
                            style={{
                                minWidth: 120,
                                borderRadius: 8,
                                padding: "10px 18px",
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            color="primary"
                            onClick={handleConfirmCopyTransfer}
                            disabled={
                                isCopyTransferLoading ||
                                !selectedAlunosIds.length ||
                                !targetContratoId ||
                                (targetContratoId === selectedContratoId && !targetCursoId)
                            }
                            style={{
                                minWidth: 140,
                                borderRadius: 8,
                                padding: "10px 22px",
                            }}
                        >
                            {isCopyTransferLoading ? "Processando..." : "Confirmar"}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>

            <Modal isOpen={assinaturaModalOpen} toggle={fecharModalAssinatura} size="lg">
                <ModalHeader toggle={fecharModalAssinatura}>
                    Assinatura digital {assinaturaContratoId ? `— Contrato ${assinaturaContratoId}` : ""}
                </ModalHeader>
                <ModalBody>
                    {assinaturaLoading && !assinaturaStatus ? (
                        <p>Carregando...</p>
                    ) : !assinaturaStatus ? (
                        <Alert color="secondary" className="mb-0">
                            Este contrato ainda não foi enviado para assinatura digital.
                        </Alert>
                    ) : (
                        <>
                            {assinaturaStatus.flashCnpj && (
                                <p className="text-muted mb-2">Contratada (Flash): {assinaturaStatus.flashCnpj}</p>
                            )}
                            <div className="d-flex align-items-center mb-3" style={{ gap: 8 }}>
                                <span>Status:</span>
                                <Badge color={getAssinaturaBadgeColor(assinaturaStatus.status)} pill>
                                    {assinaturaStatus.statusDescricao}
                                </Badge>
                                <Button
                                    size="sm"
                                    color="link"
                                    onClick={atualizarStatusAssinatura}
                                    disabled={assinaturaLoading}
                                    title="Atualizar"
                                >
                                    <i className="fa-solid fa-rotate-right"></i>
                                </Button>
                            </div>

                            {assinaturaStatus.mensagemErro && (
                                <Alert color="danger">{assinaturaStatus.mensagemErro}</Alert>
                            )}

                            {assinaturaStatus.status === 5 && (
                                <Alert color="success" className="d-flex align-items-center justify-content-between">
                                    <span>Contrato assinado por todas as partes. PDF disponível.</span>
                                    <Button color="success" size="sm" onClick={() => downloadContratoPdf(assinaturaStatus.contratoId)}>
                                        <i className="fa-solid fa-download mr-1"></i> Baixar PDF assinado
                                    </Button>
                                </Alert>
                            )}

                            <h5 className="mt-3">Signatários</h5>
                            {assinaturaStatus.signatarios.length === 0 ? (
                                <p className="text-muted">Aguardando geração dos links de assinatura...</p>
                            ) : (
                                <Table responsive size="sm">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>E-mail</th>
                                            <th>Assinou?</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {assinaturaStatus.signatarios.map((s, idx) => (
                                            <tr key={idx}>
                                                <td>{s.name}</td>
                                                <td>{s.email}</td>
                                                <td>
                                                    <Badge color={s.hasSigned ? "success" : "secondary"} pill>
                                                        {s.hasSigned ? "Assinou" : "Pendente"}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    {s.link ? (
                                                        <>
                                                            <Button
                                                                size="sm"
                                                                color="primary"
                                                                className="mr-1"
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(s.link || "");
                                                                    showToast("success", "Link copiado.");
                                                                }}
                                                                title="Copiar link"
                                                            >
                                                                <i className="fa-solid fa-copy"></i>
                                                            </Button>
                                                            {s.phone && (
                                                                <a
                                                                    href={`https://wa.me/${(s.phone || "").replace(/\D/g, "")}?text=${encodeURIComponent("Link para assinatura do contrato: " + s.link)}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="btn btn-sm btn-success"
                                                                    title="Enviar por WhatsApp"
                                                                >
                                                                    <i className="fa-brands fa-whatsapp"></i>
                                                                </a>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span className="text-muted">—</span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </>
                    )}
                </ModalBody>
            </Modal>

            <ExportContratoRelatorioModal
                isOpen={isExportRelatorioModalOpen}
                toggle={() => setIsExportRelatorioModalOpen(false)}
                representantes={listRepresentanteComercial}
                selectedVendedorId={dataSearch.vendedorId}
                onExportPdf={(vendedorId) => exportContratoStatusReportPdf(getContratoStatusReportFilters(vendedorId))}
                onExportExcel={(vendedorId) => exportContratoStatusReportExcel(getContratoStatusReportFilters(vendedorId))}
            />
        </>
    );
};

export default Contrato;
